// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.weave-inputs-container {
  padding: 1.5rem;
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  min-height: 100vh;
}
html[data-coreui-theme=dark] .weave-inputs-container {
  background: linear-gradient(135deg, #1a1d24 0%, #2c3034 100%);
  color: var(--cui-body-color, #fff);
}
.weave-inputs-container .weave-form-card {
  border: none;
  border-radius: 20px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
  transition: transform 0.3s ease;
}
.weave-inputs-container .weave-form-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.12);
}
html[data-coreui-theme=dark] .weave-inputs-container .weave-form-card {
  background: linear-gradient(135deg, var(--cui-dark-bg, #212631) 0%, var(--cui-dark-bg-subtle, #2c3034) 100%);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
}
html[data-coreui-theme=dark] .weave-inputs-container .weave-form-card:hover {
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.4);
}
.weave-inputs-container .weave-form-card .weave-form-header {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  padding: 1.5rem 2rem;
  border: none;
}
.weave-inputs-container .weave-form-card .weave-form-header h5 {
  margin: 0;
  font-weight: 700;
  font-size: 1.3rem;
  letter-spacing: 0.5px;
}
.weave-inputs-container .weave-form-card .card-body {
  padding: 2rem;
}
html[data-coreui-theme=dark] .weave-inputs-container .weave-form-card .card-body {
  background: var(--cui-dark-bg, #212631);
}
.weave-inputs-container .weave-tabs-card {
  border: none;
  border-radius: 20px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  margin-bottom: 2rem;
}
html[data-coreui-theme=dark] .weave-inputs-container .weave-tabs-card {
  background: var(--cui-dark-bg, #212631);
  border-color: var(--cui-dark-border-subtle, #333);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
}
.weave-inputs-container .weave-tabs-card .tabs-header {
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  padding: 1rem 1.25rem;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: nowrap;
  gap: 0.5rem;
}
html[data-coreui-theme=dark] .weave-inputs-container .weave-tabs-card .tabs-header {
  background: linear-gradient(135deg, var(--cui-dark-bg-subtle, #2c3034) 0%, var(--cui-dark-bg, #212631) 100%);
  border-bottom-color: var(--cui-dark-border-subtle, #333);
}
.weave-inputs-container .weave-tabs-card .tabs-header .weave-tabs {
  border: none;
  gap: 0.35rem;
  flex-wrap: nowrap;
  flex: 0 0 auto;
}
.weave-inputs-container .weave-tabs-card .tabs-header .weave-tabs .nav-item {
  flex: 0 0 auto;
}
.weave-inputs-container .weave-tabs-card .tabs-header .weave-tabs .nav-item .weave-tab-link {
  border: none;
  border-radius: 12px;
  padding: 0.55rem 1rem;
  font-weight: 600;
  color: #6c757d;
  background: transparent;
  transition: all 0.3s ease;
  position: relative;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  font-size: 0.8rem;
  white-space: nowrap;
}
.weave-inputs-container .weave-tabs-card .tabs-header .weave-tabs .nav-item .weave-tab-link:hover {
  color: #495057;
  background: rgba(255, 255, 255, 0.7);
  transform: translateY(-2px);
}
html[data-coreui-theme=dark] .weave-inputs-container .weave-tabs-card .tabs-header .weave-tabs .nav-item .weave-tab-link {
  color: var(--cui-secondary-color, #8a93a2);
}
html[data-coreui-theme=dark] .weave-inputs-container .weave-tabs-card .tabs-header .weave-tabs .nav-item .weave-tab-link:hover {
  color: var(--cui-body-color, #fff);
  background: rgba(255, 255, 255, 0.1);
}
.weave-inputs-container .weave-tabs-card .tabs-header .weave-tabs .nav-item .weave-tab-link.active {
  color: white;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
}
.weave-inputs-container .weave-tabs-card .tabs-header .weave-tabs .nav-item .weave-tab-link.active::after {
  content: "";
  position: absolute;
  bottom: -1.5rem;
  left: 50%;
  transform: translateX(-50%);
  width: 0;
  height: 0;
  border-left: 8px solid transparent;
  border-right: 8px solid transparent;
  border-top: 8px solid #764ba2;
}
.weave-inputs-container .weave-tabs-card .tabs-header .weave-tabs .nav-item .weave-tab-link svg {
  font-size: 1.1rem;
}
.weave-inputs-container .weave-tabs-card .tabs-header .tabs-photo-upload {
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
  min-width: 0;
  margin-left: 0.35rem;
  margin-right: 0;
}
.weave-inputs-container .weave-tabs-card .tabs-header .table-controls {
  display: flex;
  flex-direction: column;
  gap: 0;
  min-width: fit-content;
  margin-left: auto;
  margin-right: 6.35rem;
  align-self: flex-start;
  margin-top: -0.12rem;
}
.weave-inputs-container .weave-tabs-card .tabs-header .table-controls .bulk-controls-row {
  display: flex;
  gap: 0.55rem;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: flex-end;
}
.weave-inputs-container .weave-tabs-card .tabs-header .table-controls .bulk-controls-row .control-group:last-child {
  margin-top: 0.22rem;
  margin-left: 0.3rem;
}
.weave-inputs-container .weave-tabs-card .tabs-header .table-controls .bulk-controls-row .control-group:last-child .btn:not(.input-group .btn) {
  font-size: 0.74rem;
  padding: 0.34rem 0.78rem;
  border-width: 1.8px;
}
.weave-inputs-container .weave-tabs-card .tabs-header .table-controls .bulk-controls-row .control-group {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.25rem;
}
.weave-inputs-container .weave-tabs-card .tabs-header .table-controls .bulk-controls-row .control-group .control-label {
  font-size: 0.7rem;
  font-weight: 600;
  color: #6c757d;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin: 0;
  white-space: nowrap;
}
html[data-coreui-theme=dark] .weave-inputs-container .weave-tabs-card .tabs-header .table-controls .bulk-controls-row .control-group .control-label {
  color: var(--cui-secondary-color, #8a93a2);
}
.weave-inputs-container .weave-tabs-card .tabs-header .table-controls .bulk-controls-row .control-group .bulk-input-group {
  min-width: 80px;
  max-width: 108px;
}
.weave-inputs-container .weave-tabs-card .tabs-header .table-controls .bulk-controls-row .control-group .bulk-input-group .bulk-number-input {
  font-size: 0.75rem;
  text-align: center;
  padding: 0.25rem 0.5rem;
  border-radius: 0;
  background-color: #fff;
  border-left: none;
  border-right: none;
}
.weave-inputs-container .weave-tabs-card .tabs-header .table-controls .bulk-controls-row .control-group .bulk-input-group .bulk-number-input.has-left-button {
  border-left: 0;
}
html[data-coreui-theme=dark] .weave-inputs-container .weave-tabs-card .tabs-header .table-controls .bulk-controls-row .control-group .bulk-input-group .bulk-number-input {
  background-color: var(--cui-dark-bg, #212631);
  border-color: var(--cui-dark-border-subtle, #333);
  color: var(--cui-body-color, #fff);
}
.weave-inputs-container .weave-tabs-card .tabs-header .table-controls .bulk-controls-row .control-group .bulk-input-group .bulk-number-input:focus {
  border-color: #667eea;
  box-shadow: 0 0 0 2px rgba(102, 126, 234, 0.25);
  z-index: 3;
}
.weave-inputs-container .weave-tabs-card .tabs-header .table-controls .bulk-controls-row .control-group .bulk-input-group .bulk-number-input::-webkit-outer-spin-button, .weave-inputs-container .weave-tabs-card .tabs-header .table-controls .bulk-controls-row .control-group .bulk-input-group .bulk-number-input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.weave-inputs-container .weave-tabs-card .tabs-header .table-controls .bulk-controls-row .control-group .bulk-input-group .bulk-number-input[type=number] {
  appearance: textfield;
  -moz-appearance: textfield;
}
.weave-inputs-container .weave-tabs-card .tabs-header .table-controls .bulk-controls-row .control-group .bulk-input-group .btn {
  border-radius: 0;
  padding: 0.25rem 0.5rem;
}
.weave-inputs-container .weave-tabs-card .tabs-header .table-controls .bulk-controls-row .control-group .bulk-input-group .btn.btn-outline-success {
  border-color: #28a745;
  color: #28a745;
  background-color: transparent;
}
.weave-inputs-container .weave-tabs-card .tabs-header .table-controls .bulk-controls-row .control-group .bulk-input-group .btn.btn-outline-success:hover {
  background-color: #28a745;
  border-color: #28a745;
  color: white;
  transform: none;
}
.weave-inputs-container .weave-tabs-card .tabs-header .table-controls .bulk-controls-row .control-group .bulk-input-group .btn.btn-outline-success:focus {
  box-shadow: 0 0 0 2px rgba(40, 167, 69, 0.25);
}
.weave-inputs-container .weave-tabs-card .tabs-header .table-controls .bulk-controls-row .control-group .bulk-input-group .btn.left-btn {
  border-radius: 6px 0 0 6px;
  border-right: none;
}
.weave-inputs-container .weave-tabs-card .tabs-header .table-controls .bulk-controls-row .control-group .bulk-input-group .btn.right-btn {
  border-radius: 0 6px 6px 0;
  border-left: none;
}
.weave-inputs-container .weave-tabs-card .tabs-header .table-controls .bulk-controls-row .control-group .btn:not(.input-group .btn) {
  transition: all 0.2s ease;
  border-width: 1.5px;
  font-weight: 500;
  padding: 0.28rem 0.6rem;
  border-radius: 6px;
  font-size: 0.68rem;
  white-space: nowrap;
}
.weave-inputs-container .weave-tabs-card .tabs-header .table-controls .bulk-controls-row .control-group .btn:not(.input-group .btn):hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
}
.weave-inputs-container .weave-tabs-card .tabs-header .table-controls .bulk-controls-row .control-group .btn:not(.input-group .btn).btn-outline-danger {
  border-color: #dc3545;
  color: #dc3545;
}
.weave-inputs-container .weave-tabs-card .tabs-header .table-controls .bulk-controls-row .control-group .btn:not(.input-group .btn).btn-outline-danger:hover {
  background-color: #dc3545;
  border-color: #dc3545;
  color: white;
}
.weave-inputs-container .weave-tabs-card .tabs-header .table-controls .bulk-controls-row .control-group .btn:not(.input-group .btn).btn-outline-danger:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  transform: none;
}
.weave-inputs-container .weave-tabs-card .tabs-header .table-controls .bulk-controls-row .control-group .btn:not(.input-group .btn).btn-outline-danger:disabled:hover {
  transform: none;
  box-shadow: none;
}
.weave-inputs-container .weave-tabs-card .weave-table-container {
  max-height: 600px;
  overflow: auto;
}
.weave-inputs-container .weave-tabs-card .weave-table-container::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}
.weave-inputs-container .weave-tabs-card .weave-table-container::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}
.weave-inputs-container .weave-tabs-card .weave-table-container::-webkit-scrollbar-thumb {
  background: linear-gradient(135deg, #667eea, #764ba2);
  border-radius: 4px;
}
.weave-inputs-container .weave-tabs-card .weave-table-container::-webkit-scrollbar-thumb:hover {
  background: linear-gradient(135deg, #5a6fd8, #6a42a0);
}
html[data-coreui-theme=dark] .weave-inputs-container .weave-tabs-card .weave-table-container::-webkit-scrollbar-track {
  background: var(--cui-dark-bg-subtle, #2c3034);
}
html[data-coreui-theme=dark] .weave-inputs-container .weave-tabs-card .weave-table-container::-webkit-scrollbar-thumb {
  background: linear-gradient(135deg, #4a5568, #2d3748);
}
html[data-coreui-theme=dark] .weave-inputs-container .weave-tabs-card .weave-table-container::-webkit-scrollbar-thumb:hover {
  background: linear-gradient(135deg, #2d3748, #1a202c);
}
.weave-inputs-container .weave-tabs-card .weave-table {
  margin-bottom: 0 !important;
  border-collapse: separate;
  border-spacing: 0;
  --sticky-color-width: 150px;
  --sticky-code-width: 120px;
  --sticky-yarn-width: 150px;
  --sticky-cell-bg: #ffffff;
}
.weave-inputs-container .weave-tabs-card .weave-table .table-input {
  border: none;
  background: transparent;
  text-align: center;
  font-weight: 500;
  padding: 0.25rem;
  min-width: 50px;
  transition: all 0.2s ease;
}
.weave-inputs-container .weave-tabs-card .weave-table .table-input:focus {
  box-shadow: 0 0 0 2px rgba(102, 126, 234, 0.25);
  background-color: rgba(102, 126, 234, 0.05);
  border-radius: 6px;
}
html[data-coreui-theme=dark] .weave-inputs-container .weave-tabs-card .weave-table .table-input {
  color: var(--cui-body-color, #fff);
  background: transparent;
}
html[data-coreui-theme=dark] .weave-inputs-container .weave-tabs-card .weave-table .table-input:focus {
  background-color: rgba(102, 126, 234, 0.1);
}
.weave-inputs-container .weave-tabs-card .weave-table .table-input[type=number] {
  appearance: textfield;
  -moz-appearance: textfield;
}
.weave-inputs-container .weave-tabs-card .weave-table .table-input[type=number]::-webkit-outer-spin-button, .weave-inputs-container .weave-tabs-card .weave-table .table-input[type=number]::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.weave-inputs-container .weave-tabs-card .weave-table th {
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  border: 1px solid #dee2e6;
  font-weight: 600;
  font-size: 0.75rem;
  text-align: center;
  padding: 0.5rem 0.25rem;
  color: #495057;
  position: sticky;
  top: 0;
  z-index: 10;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
html[data-coreui-theme=dark] .weave-inputs-container .weave-tabs-card .weave-table th {
  background: linear-gradient(135deg, var(--cui-dark-bg-subtle, #2c3034) 0%, var(--cui-dark-bg, #212631) 100%);
  border-color: var(--cui-dark-border-subtle, #333);
  color: var(--cui-body-color, #fff);
}
.weave-inputs-container .weave-tabs-card .weave-table th.color-column {
  min-width: var(--sticky-color-width);
  max-width: var(--sticky-color-width);
  background: linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%);
  position: sticky;
  left: 0;
  z-index: 14;
}
.weave-inputs-container .weave-tabs-card .weave-table th.code-column {
  min-width: var(--sticky-code-width);
  max-width: var(--sticky-code-width);
  background: linear-gradient(135deg, #f3e5f5 0%, #e1bee7 100%);
  position: sticky;
  left: var(--sticky-color-width);
  z-index: 13;
}
.weave-inputs-container .weave-tabs-card .weave-table th.yarn-column {
  min-width: var(--sticky-yarn-width);
  max-width: var(--sticky-yarn-width);
  background: linear-gradient(135deg, #e8f5e8 0%, #c8e6c9 100%);
  position: sticky;
  left: calc(var(--sticky-color-width) + var(--sticky-code-width));
  z-index: 12;
  box-shadow: 1px 0 0 #ced4da;
}
.weave-inputs-container .weave-tabs-card .weave-table th.number-column {
  min-width: 45px;
  max-width: 45px;
  font-size: 0.7rem;
  background: linear-gradient(135deg, #fff3e0 0%, #ffcc02 100%);
}
.weave-inputs-container .weave-tabs-card .weave-table th.total-column {
  min-width: 70px;
  max-width: 70px;
  background: linear-gradient(135deg, #e8f5e8 0%, #c8e6c9 100%);
}
.weave-inputs-container .weave-tabs-card .weave-table th.percent-column {
  min-width: 60px;
  max-width: 60px;
  background: linear-gradient(135deg, #fff3e0 0%, #ffe0b2 100%);
}
.weave-inputs-container .weave-tabs-card .weave-table th.weight-column {
  min-width: 80px;
  max-width: 80px;
  background: linear-gradient(135deg, #e1f5fe 0%, #b3e5fc 100%);
}
.weave-inputs-container .weave-tabs-card .weave-table th.action-column {
  min-width: 70px;
  max-width: 70px;
  background: linear-gradient(135deg, #ffebee 0%, #ffcdd2 100%);
}
.weave-inputs-container .weave-tabs-card .weave-table th .header-with-action {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
}
.weave-inputs-container .weave-tabs-card .weave-table th .header-with-action > span {
  width: 100%;
  text-align: center;
  padding-right: 1.4rem;
}
.weave-inputs-container .weave-tabs-card .weave-table th .header-add-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 22px;
  height: 22px;
  padding: 0;
  border-radius: 6px;
  flex-shrink: 0;
}
.weave-inputs-container .weave-tabs-card .weave-table td {
  border: 1px solid #dee2e6;
  padding: 0.25rem;
  text-align: center;
  vertical-align: middle;
  font-size: 0.875rem;
}
html[data-coreui-theme=dark] .weave-inputs-container .weave-tabs-card .weave-table td {
  border-color: var(--cui-dark-border-subtle, #333);
  color: var(--cui-body-color, #fff);
}
.weave-inputs-container .weave-tabs-card .weave-table td.color-column {
  min-width: var(--sticky-color-width);
  max-width: var(--sticky-color-width);
  padding: 0.5rem;
  position: sticky;
  left: 0;
  z-index: 11;
  background-color: var(--sticky-cell-bg);
}
.weave-inputs-container .weave-tabs-card .weave-table td.color-column .form-select {
  font-size: 0.75rem;
  border: 1px solid #ced4da;
  border-radius: 8px;
  transition: all 0.2s ease;
  background-color: white;
}
.weave-inputs-container .weave-tabs-card .weave-table td.color-column .form-select:focus {
  border-color: #667eea;
  box-shadow: 0 0 0 2px rgba(102, 126, 234, 0.25);
}
html[data-coreui-theme=dark] .weave-inputs-container .weave-tabs-card .weave-table td.color-column .form-select {
  background-color: var(--cui-dark-bg, #212631);
  border-color: var(--cui-dark-border-subtle, #333);
  color: var(--cui-body-color, #fff);
}
html[data-coreui-theme=dark] .weave-inputs-container .weave-tabs-card .weave-table td.color-column .form-select:focus {
  border-color: var(--cui-primary, #0d6efd);
}
.weave-inputs-container .weave-tabs-card .weave-table td.code-column {
  min-width: var(--sticky-code-width);
  max-width: var(--sticky-code-width);
  padding: 0.5rem;
  position: sticky;
  left: var(--sticky-color-width);
  z-index: 10;
  background-color: var(--sticky-cell-bg);
}
.weave-inputs-container .weave-tabs-card .weave-table td.code-column .color-code {
  display: inline-block;
  background: linear-gradient(135deg, #f8f9fa, #e9ecef);
  padding: 0.25rem 0.5rem;
  border-radius: 8px;
  font-family: "Courier New", monospace;
  font-weight: 600;
  color: #495057;
  border: 1px solid #dee2e6;
  font-size: 0.75rem;
}
html[data-coreui-theme=dark] .weave-inputs-container .weave-tabs-card .weave-table td.code-column .color-code {
  background: linear-gradient(135deg, var(--cui-dark-bg-subtle, #2c3034), var(--cui-dark-bg, #212631));
  color: var(--cui-body-color, #fff);
  border-color: var(--cui-dark-border-subtle, #333);
}
.weave-inputs-container .weave-tabs-card .weave-table td.yarn-column {
  min-width: var(--sticky-yarn-width);
  max-width: var(--sticky-yarn-width);
  padding: 0.5rem;
  position: sticky;
  left: calc(var(--sticky-color-width) + var(--sticky-code-width));
  z-index: 9;
  background-color: var(--sticky-cell-bg);
  box-shadow: 1px 0 0 #ced4da;
}
.weave-inputs-container .weave-tabs-card .weave-table td.yarn-column .form-select {
  font-size: 0.75rem;
  border: 1px solid #ced4da;
  border-radius: 8px;
  transition: all 0.2s ease;
  background-color: white;
}
.weave-inputs-container .weave-tabs-card .weave-table td.yarn-column .form-select:focus {
  border-color: #667eea;
  box-shadow: 0 0 0 2px rgba(102, 126, 234, 0.25);
}
html[data-coreui-theme=dark] .weave-inputs-container .weave-tabs-card .weave-table td.yarn-column .form-select {
  background-color: var(--cui-dark-bg, #212631);
  border-color: var(--cui-dark-border-subtle, #333);
  color: var(--cui-body-color, #fff);
}
html[data-coreui-theme=dark] .weave-inputs-container .weave-tabs-card .weave-table td.yarn-column .form-select:focus {
  border-color: var(--cui-primary, #0d6efd);
}
.weave-inputs-container .weave-tabs-card .weave-table td.number-column {
  min-width: 45px;
  max-width: 45px;
  padding: 0.1rem;
}
.weave-inputs-container .weave-tabs-card .weave-table td.total-column {
  min-width: 70px;
  max-width: 70px;
  background-color: rgba(200, 230, 201, 0.1);
  font-weight: 600;
  color: #2e7d32;
}
.weave-inputs-container .weave-tabs-card .weave-table td.percent-column {
  min-width: 60px;
  max-width: 60px;
  background-color: rgba(255, 224, 178, 0.1);
  font-weight: 600;
  color: #ef6c00;
}
.weave-inputs-container .weave-tabs-card .weave-table td.weight-column {
  min-width: 80px;
  max-width: 80px;
  padding: 0.25rem;
  background-color: rgba(179, 229, 252, 0.1);
}
.weave-inputs-container .weave-tabs-card .weave-table td.weight-column .table-input {
  font-size: 0.7rem;
  text-align: center;
}
.weave-inputs-container .weave-tabs-card .weave-table td.weight-column .table-input::placeholder {
  font-family: inherit;
  font-size: 0.65rem;
}
.weave-inputs-container .weave-tabs-card .weave-table td.action-column {
  min-width: 70px;
  max-width: 70px;
  padding: 0.25rem;
}
.weave-inputs-container .weave-tabs-card .weave-table td.action-column .btn {
  padding: 0.25rem 0.5rem;
  transition: all 0.2s ease;
  border-radius: 6px;
}
.weave-inputs-container .weave-tabs-card .weave-table td.action-column .btn:hover {
  transform: scale(1.05);
}
.weave-inputs-container .weave-tabs-card .weave-table tbody tr {
  transition: all 0.2s ease;
}
.weave-inputs-container .weave-tabs-card .weave-table tbody tr:hover {
  background-color: rgba(102, 126, 234, 0.02);
}
.weave-inputs-container .weave-tabs-card .weave-table tbody tr:hover td {
  border-color: rgba(102, 126, 234, 0.3);
}
.weave-inputs-container .weave-tabs-card .weave-table tbody tr:nth-child(even) {
  background-color: rgba(248, 249, 250, 0.5);
}
html[data-coreui-theme=dark] .weave-inputs-container .weave-tabs-card .weave-table tbody tr:hover {
  background-color: rgba(102, 126, 234, 0.1);
}
html[data-coreui-theme=dark] .weave-inputs-container .weave-tabs-card .weave-table tbody tr:hover td {
  border-color: rgba(102, 126, 234, 0.5);
}
html[data-coreui-theme=dark] .weave-inputs-container .weave-tabs-card .weave-table tbody tr:nth-child(even) {
  background-color: rgba(44, 48, 52, 0.3);
}
.weave-inputs-container .weave-tabs-card .weave-table tbody tr.total-row {
  background: linear-gradient(135deg, #e8f5e8 0%, #c8e6c9 100%);
  font-weight: 700;
}
.weave-inputs-container .weave-tabs-card .weave-table tbody tr.total-row td {
  border-color: #4caf50;
  border-width: 2px;
  color: #1b5e20;
}
.weave-inputs-container .weave-tabs-card .weave-table tbody tr.total-row td.total-column, .weave-inputs-container .weave-tabs-card .weave-table tbody tr.total-row td.percent-column {
  background: linear-gradient(135deg, #4caf50, #2e7d32);
  color: white;
  font-size: 1rem;
}
.weave-inputs-container .weave-tabs-card .weave-table tbody tr.total-row:hover {
  background: linear-gradient(135deg, #c8e6c9 0%, #a5d6a7 100%);
}
.weave-inputs-container .weave-tabs-card .weave-table tbody tr.factor-row td.factor-cell {
  border-left: none !important;
  border-right: none !important;
}
.weave-inputs-container .weave-tabs-card .weave-table .sticky-summary-label {
  position: sticky;
  left: 0;
  min-width: calc(var(--sticky-color-width) + var(--sticky-code-width) + var(--sticky-yarn-width));
  max-width: calc(var(--sticky-color-width) + var(--sticky-code-width) + var(--sticky-yarn-width));
  z-index: 8;
  background-color: var(--sticky-cell-bg);
  box-shadow: 1px 0 0 #ced4da;
}
html[data-coreui-theme=dark] .weave-inputs-container .weave-tabs-card .weave-table {
  --sticky-cell-bg: var(--cui-dark-bg, #212631);
}
html[data-coreui-theme=dark] .weave-inputs-container .weave-tabs-card .weave-table th.yarn-column,
html[data-coreui-theme=dark] .weave-inputs-container .weave-tabs-card .weave-table td.yarn-column,
html[data-coreui-theme=dark] .weave-inputs-container .weave-tabs-card .weave-table .sticky-summary-label {
  box-shadow: 1px 0 0 var(--cui-dark-border-subtle, #333);
}
@media (min-width: 769px) {
  .weave-inputs-container .weave-tabs-card .tabs-header {
    align-items: center;
  }
  .weave-inputs-container .weave-tabs-card .tabs-header .weave-tabs {
    display: flex !important;
    flex-direction: row !important;
    flex-wrap: nowrap !important;
    align-items: center;
    margin-bottom: 0;
  }
  .weave-inputs-container .weave-tabs-card .tabs-header .weave-tabs .nav-item {
    width: auto !important;
    flex: 0 0 auto;
  }
  .weave-inputs-container .weave-tabs-card .tabs-header .weave-tabs .nav-item .weave-tab-link {
    padding: 0.68rem 1.25rem;
    font-size: 0.86rem;
  }
  .weave-inputs-container .weave-tabs-card .tabs-header .weave-tabs .nav-item .weave-tab-link.active::after {
    display: none;
  }
  .weave-inputs-container .weave-tabs-card .tabs-header .table-controls .bulk-controls-row {
    align-items: flex-start;
    gap: 0.72rem;
  }
  .weave-inputs-container .weave-tabs-card .tabs-header .table-controls .bulk-controls-row .control-group:nth-child(-n+2) {
    margin-left: 2.2rem;
  }
  .weave-inputs-container .weave-tabs-card .tabs-header .table-controls .bulk-controls-row .control-group:last-child {
    margin-top: 1.26rem;
    margin-left: 2.4rem;
  }
  .weave-inputs-container .weave-tabs-card .tabs-header .table-controls .bulk-controls-row .control-group:last-child .btn:not(.input-group .btn) {
    font-size: 0.72rem;
    padding: 0.32rem 0.74rem;
  }
  .weave-inputs-container .weave-tabs-card .tabs-header .table-controls .control-group {
    gap: 0.3rem;
  }
  .weave-inputs-container .weave-tabs-card .tabs-header .table-controls .control-group .control-label {
    font-size: 0.74rem;
  }
  .weave-inputs-container .weave-tabs-card .tabs-header .table-controls .control-group .btn:not(.input-group .btn) {
    font-size: 0.64rem;
    padding: 0.22rem 0.52rem;
  }
}
.weave-inputs-container .form-label {
  font-weight: 600;
  color: #495057;
  margin-bottom: 0.5rem;
  font-size: 0.875rem;
}
html[data-coreui-theme=dark] .weave-inputs-container .form-label {
  color: var(--cui-body-color, #fff);
}
.weave-inputs-container .form-label::after {
  content: "";
  display: inline-block;
  width: 0;
  height: 0;
  margin-left: 0.5rem;
  border-left: 3px solid transparent;
  border-right: 3px solid transparent;
  border-bottom: 3px solid #667eea;
  transition: all 0.2s ease;
}
.weave-inputs-container .quick-create-select-group .quick-create-searchable-select {
  flex: 1 1 auto;
  width: 1%;
  min-width: 0;
}
.weave-inputs-container .quick-create-select-group .quick-create-searchable-select .select-trigger {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  border-right: 0;
}
.weave-inputs-container .quick-create-select-group .btn {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 38px;
}
.weave-inputs-container .form-control,
.weave-inputs-container .form-select {
  border: 2px solid #e9ecef;
  border-radius: 0.5rem;
  padding: 0.75rem 1rem;
  font-size: 0.875rem;
  transition: all 0.3s ease;
}
.weave-inputs-container .form-control:focus,
.weave-inputs-container .form-select:focus {
  border-color: #667eea;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
  transform: translateY(-1px);
}
.weave-inputs-container .form-control::placeholder,
.weave-inputs-container .form-select::placeholder {
  color: #adb5bd;
  font-style: italic;
}
.weave-inputs-container .form-control.is-invalid,
.weave-inputs-container .form-select.is-invalid {
  border-color: #dc3545;
}
.weave-inputs-container .form-control.is-invalid:focus,
.weave-inputs-container .form-select.is-invalid:focus {
  border-color: #dc3545;
  box-shadow: 0 0 0 3px rgba(220, 53, 69, 0.1);
}
html[data-coreui-theme=dark] .weave-inputs-container .form-control,
html[data-coreui-theme=dark] .weave-inputs-container .form-select {
  background-color: var(--cui-dark-bg, #212631);
  border-color: var(--cui-dark-border-subtle, #333);
  color: var(--cui-body-color, #fff);
}
html[data-coreui-theme=dark] .weave-inputs-container .form-control:focus,
html[data-coreui-theme=dark] .weave-inputs-container .form-select:focus {
  border-color: var(--cui-primary, #0d6efd);
}
html[data-coreui-theme=dark] .weave-inputs-container .form-control::placeholder,
html[data-coreui-theme=dark] .weave-inputs-container .form-select::placeholder {
  color: var(--cui-secondary-color, #8a93a2);
}
.weave-inputs-container .form-control[type=number] {
  appearance: textfield;
  -moz-appearance: textfield;
}
.weave-inputs-container .form-control[type=number]::-webkit-outer-spin-button, .weave-inputs-container .form-control[type=number]::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.weave-inputs-container .btn {
  border-radius: 0.5rem;
  padding: 0.75rem 1.5rem;
  font-weight: 600;
  font-size: 0.875rem;
  transition: all 0.3s ease;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
.weave-inputs-container .btn.btn-primary {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border: none;
}
.weave-inputs-container .btn.btn-primary:hover {
  background: linear-gradient(135deg, #5a6fd8 0%, #6a42a0 100%);
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(102, 126, 234, 0.3);
}
.weave-inputs-container .btn.btn-primary:disabled {
  background: #adb5bd;
  transform: none;
  box-shadow: none;
}
.weave-inputs-container .btn.btn-secondary.btn-outline {
  border: 2px solid #6c757d;
  color: #6c757d;
}
.weave-inputs-container .btn.btn-secondary.btn-outline:hover {
  background-color: #6c757d;
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(108, 117, 125, 0.2);
}
.weave-inputs-container .alert {
  border-radius: 0.5rem;
  border: none;
  padding: 1rem 1.5rem;
  margin-bottom: 1.5rem;
}
.weave-inputs-container .alert.alert-success {
  background: linear-gradient(135deg, #d4edda 0%, #c3e6cb 100%);
  color: #155724;
  border-left: 4px solid #28a745;
}
.weave-inputs-container .alert.alert-danger {
  background: linear-gradient(135deg, #f8d7da 0%, #f5c6cb 100%);
  color: #721c24;
  border-left: 4px solid #dc3545;
}
.weave-inputs-container .alert.alert-info {
  background: linear-gradient(135deg, #d1ecf1 0%, #bee5eb 100%);
  color: #0c5460;
  border-left: 4px solid #17a2b8;
}
.weave-inputs-container .invalid-feedback {
  display: block !important;
  font-size: 0.75rem;
  color: #dc3545;
  margin-top: 0.25rem;
  font-weight: 500;
}
.weave-inputs-container .invalid-feedback::before {
  content: "⚠ ";
  margin-right: 0.25rem;
}
.weave-inputs-container .fabric-weight-input-group {
  display: flex;
  align-items: center;
  background: #fff;
  border: 2px solid #e9ecef;
  border-radius: 0.5rem;
  overflow: hidden;
  transition: all 0.3s ease;
}
.weave-inputs-container .fabric-weight-input-group:focus-within {
  border-color: #667eea;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}
html[data-coreui-theme=dark] .weave-inputs-container .fabric-weight-input-group {
  background: var(--cui-dark-bg, #212631);
  border-color: var(--cui-dark-border-subtle, #333);
}
html[data-coreui-theme=dark] .weave-inputs-container .fabric-weight-input-group:focus-within {
  border-color: var(--cui-primary, #0d6efd);
}
.weave-inputs-container .fabric-weight-input-group .weight-input-section {
  display: flex;
  align-items: center;
  flex: 1 1;
  padding: 0 0.5rem;
}
.weave-inputs-container .fabric-weight-input-group .weight-whole,
.weave-inputs-container .fabric-weight-input-group .weight-decimal {
  border: none !important;
  background: transparent !important;
  text-align: center;
  font-weight: 600;
  font-size: 1rem;
  padding: 0.5rem 0.25rem;
  box-shadow: none !important;
}
.weave-inputs-container .fabric-weight-input-group .weight-whole:focus,
.weave-inputs-container .fabric-weight-input-group .weight-decimal:focus {
  outline: none;
  background: rgba(102, 126, 234, 0.05) !important;
}
.weave-inputs-container .fabric-weight-input-group .weight-whole::placeholder,
.weave-inputs-container .fabric-weight-input-group .weight-decimal::placeholder {
  color: #adb5bd;
  font-weight: 400;
}
html[data-coreui-theme=dark] .weave-inputs-container .fabric-weight-input-group .weight-whole,
html[data-coreui-theme=dark] .weave-inputs-container .fabric-weight-input-group .weight-decimal {
  color: var(--cui-body-color, #fff);
}
html[data-coreui-theme=dark] .weave-inputs-container .fabric-weight-input-group .weight-whole::placeholder,
html[data-coreui-theme=dark] .weave-inputs-container .fabric-weight-input-group .weight-decimal::placeholder {
  color: var(--cui-secondary-color, #8a93a2);
}
.weave-inputs-container .fabric-weight-input-group .weight-whole::-webkit-outer-spin-button, .weave-inputs-container .fabric-weight-input-group .weight-whole::-webkit-inner-spin-button,
.weave-inputs-container .fabric-weight-input-group .weight-decimal::-webkit-outer-spin-button,
.weave-inputs-container .fabric-weight-input-group .weight-decimal::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.weave-inputs-container .fabric-weight-input-group .weight-whole[type=number],
.weave-inputs-container .fabric-weight-input-group .weight-decimal[type=number] {
  appearance: textfield;
  -moz-appearance: textfield;
}
.weave-inputs-container .fabric-weight-input-group .weight-whole {
  flex: 1 1;
  min-width: 60px;
  text-align: right;
  padding-right: 0.1rem;
}
.weave-inputs-container .fabric-weight-input-group .weight-decimal {
  width: 50px;
  min-width: 50px;
  text-align: left;
  padding-left: 0.1rem;
}
.weave-inputs-container .fabric-weight-input-group .decimal-separator {
  font-weight: 700;
  font-size: 1.2rem;
  color: #495057;
  padding: 0 0.1rem;
}
html[data-coreui-theme=dark] .weave-inputs-container .fabric-weight-input-group .decimal-separator {
  color: var(--cui-body-color, #fff);
}
.weave-inputs-container .fabric-weight-input-group .unit-label {
  font-size: 0.75rem;
  font-weight: 600;
  color: #6c757d;
  padding: 0 0.5rem;
  white-space: nowrap;
}
html[data-coreui-theme=dark] .weave-inputs-container .fabric-weight-input-group .unit-label {
  color: var(--cui-secondary-color, #8a93a2);
}
.weave-inputs-container .image-upload-section .image-upload-container {
  border: 2px dashed #ced4da;
  border-radius: 12px;
  min-height: 170px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;
  transition: all 0.2s ease;
}
.weave-inputs-container .image-upload-section .image-upload-container:hover {
  border-color: #667eea;
  background: #f8faff;
}
html[data-coreui-theme=dark] .weave-inputs-container .image-upload-section .image-upload-container {
  background: var(--cui-dark-bg, #212631);
  border-color: var(--cui-dark-border-subtle, #333);
}
html[data-coreui-theme=dark] .weave-inputs-container .image-upload-section .image-upload-container:hover {
  border-color: var(--cui-primary, #0d6efd);
  background: rgba(13, 110, 253, 0.08);
}
.weave-inputs-container .image-upload-section .upload-placeholder {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.4rem;
  color: #6c757d;
  font-size: 0.85rem;
}
.weave-inputs-container .image-upload-section .upload-placeholder .upload-hint {
  font-size: 0.75rem;
  color: #999;
}
.weave-inputs-container .image-upload-section .image-preview-wrapper {
  position: relative;
  width: 100%;
  height: 170px;
  overflow: hidden;
  border-radius: 10px;
}
.weave-inputs-container .image-upload-section .image-preview-wrapper .image-preview {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.weave-inputs-container .image-upload-section .image-preview-wrapper .remove-image-btn {
  position: absolute;
  top: 8px;
  right: 8px;
  width: 28px;
  height: 28px;
  padding: 0;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
.weave-inputs-container .image-upload-section.compact-image-upload {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}
.weave-inputs-container .image-upload-section.compact-image-upload .compact-image-row {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}
.weave-inputs-container .image-upload-section.compact-image-upload .compact-image-label {
  font-size: 0.68rem;
  font-weight: 700;
  color: #6c757d;
  letter-spacing: 0.2px;
  margin-bottom: 0;
  white-space: nowrap;
}
html[data-coreui-theme=dark] .weave-inputs-container .image-upload-section.compact-image-upload .compact-image-label {
  color: var(--cui-secondary-color, #8a93a2);
}
.weave-inputs-container .image-upload-section.compact-image-upload .image-upload-container {
  min-height: 56px;
  width: 128px;
}
.weave-inputs-container .image-upload-section.compact-image-upload .image-preview-wrapper {
  height: 64px;
}
.weave-inputs-container .image-upload-section.compact-image-upload .image-preview-wrapper .remove-image-btn {
  width: 22px;
  height: 22px;
  top: 5px;
  right: 5px;
}
.weave-inputs-container .image-upload-section.compact-image-upload .upload-placeholder {
  gap: 0.15rem;
  font-size: 0.62rem;
}
.weave-inputs-container .image-upload-section.compact-image-upload .upload-placeholder svg {
  font-size: 1rem;
}
.weave-inputs-container .image-upload-section.compact-image-upload .upload-placeholder .upload-hint {
  font-size: 0.56rem;
}
.weave-inputs-container .image-preview-modal .preview-image {
  width: 100%;
  max-height: 70vh;
  object-fit: contain;
}
.weave-inputs-container .crop-modal .crop-container {
  position: relative;
  width: 100%;
  height: 420px;
  background: #111;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}
.weave-inputs-container .crop-modal .crop-container .react-easy-crop_container {
  width: 100%;
  height: 100%;
}
.weave-inputs-container .crop-modal .crop-controls {
  padding: 1rem;
  border-top: 1px solid #e9ecef;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
  flex-wrap: wrap;
}
.weave-inputs-container .crop-modal .crop-size-options {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}
.weave-inputs-container .crop-modal .crop-size-options span {
  font-size: 0.85rem;
  font-weight: 600;
}
.weave-inputs-container .crop-modal .zoom-control {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}
.weave-inputs-container .crop-modal .zoom-control label {
  font-size: 0.85rem;
  font-weight: 600;
  margin: 0;
}
.weave-inputs-container .crop-modal .zoom-control .zoom-slider {
  width: 220px;
}
.weave-inputs-container .crop-modal .crop-actions {
  display: flex;
  gap: 0.5rem;
}
@media (max-width: 768px) {
  .weave-inputs-container {
    padding: 1rem;
  }
  .weave-inputs-container .weave-form-card,
  .weave-inputs-container .weave-tabs-card {
    border-radius: 16px;
  }
  .weave-inputs-container .weave-form-card .card-body,
  .weave-inputs-container .weave-tabs-card .card-body {
    padding: 1.5rem;
  }
}
@media (max-width: 768px) and (max-width: 768px) {
  .weave-inputs-container .row .col-md-2 {
    flex: 0 0 50%;
    max-width: 50%;
    margin-bottom: 1rem;
  }
}
@media (max-width: 768px) and (max-width: 576px) {
  .weave-inputs-container .row .col-md-2 {
    flex: 0 0 100%;
    max-width: 100%;
  }
}
@media (max-width: 768px) {
  .weave-inputs-container .tabs-header {
    padding: 1rem !important;
    flex-direction: column;
    align-items: stretch;
  }
  .weave-inputs-container .tabs-header .tabs-photo-upload {
    margin: 0 0 0.75rem 0;
    justify-content: center;
  }
  .weave-inputs-container .tabs-header .tabs-photo-upload .compact-image-upload {
    flex-direction: column;
    align-items: center;
    gap: 0.45rem;
  }
  .weave-inputs-container .tabs-header .tabs-photo-upload .compact-image-row {
    justify-content: center;
  }
  .weave-inputs-container .tabs-header .weave-tabs {
    width: 100%;
    flex-direction: column;
    margin-bottom: 1rem;
  }
  .weave-inputs-container .tabs-header .weave-tabs .nav-item {
    width: 100%;
  }
  .weave-inputs-container .tabs-header .weave-tabs .nav-item .weave-tab-link {
    text-align: center;
    padding: 0.75rem 1rem;
    width: 100%;
  }
  .weave-inputs-container .tabs-header .weave-tabs .nav-item .weave-tab-link.active::after {
    display: none;
  }
  .weave-inputs-container .tabs-header .table-controls {
    width: 100%;
    min-width: auto;
  }
  .weave-inputs-container .tabs-header .table-controls .bulk-controls-row {
    justify-content: center;
    gap: 0.5rem;
  }
  .weave-inputs-container .tabs-header .table-controls .bulk-controls-row .control-group .bulk-input-group {
    min-width: 70px;
    max-width: 90px;
  }
  .weave-inputs-container .tabs-header .table-controls .bulk-controls-row .control-group .control-label {
    font-size: 0.65rem;
  }
  .weave-inputs-container .weave-table-container {
    max-height: 400px;
  }
  .weave-inputs-container .weave-table {
    --sticky-color-width: 120px;
    --sticky-code-width: 100px;
    --sticky-yarn-width: 120px;
  }
  .weave-inputs-container .weave-table th.color-column,
  .weave-inputs-container .weave-table td.color-column {
    min-width: var(--sticky-color-width);
    max-width: var(--sticky-color-width);
  }
  .weave-inputs-container .weave-table th.code-column,
  .weave-inputs-container .weave-table td.code-column {
    min-width: var(--sticky-code-width);
    max-width: var(--sticky-code-width);
  }
  .weave-inputs-container .weave-table th.yarn-column,
  .weave-inputs-container .weave-table td.yarn-column {
    min-width: var(--sticky-yarn-width);
    max-width: var(--sticky-yarn-width);
  }
  .weave-inputs-container .weave-table th.number-column,
  .weave-inputs-container .weave-table td.number-column {
    min-width: 40px;
    max-width: 40px;
  }
  .weave-inputs-container .weave-table th.weight-column,
  .weave-inputs-container .weave-table td.weight-column {
    min-width: 70px;
    max-width: 70px;
  }
}
@media (max-width: 576px) {
  .weave-inputs-container .btn {
    padding: 0.5rem 1rem;
    font-size: 0.75rem;
  }
  .weave-inputs-container .form-control,
  .weave-inputs-container .form-select {
    padding: 0.5rem 0.75rem;
    font-size: 0.8rem;
  }
  .weave-inputs-container .tabs-header .table-controls .bulk-controls-row {
    flex-direction: column;
    align-items: center;
  }
  .weave-inputs-container .tabs-header .table-controls .bulk-controls-row .control-group {
    width: 100%;
    max-width: 200px;
  }
  .weave-inputs-container .tabs-header .table-controls .bulk-controls-row .control-group .bulk-input-group {
    min-width: 100px;
    max-width: 150px;
  }
  .weave-inputs-container .weave-table {
    font-size: 0.75rem;
  }
  .weave-inputs-container .weave-table .table-input {
    font-size: 0.7rem;
    padding: 0.15rem;
  }
  .weave-inputs-container .weave-table th {
    padding: 0.25rem 0.15rem;
    font-size: 0.65rem;
  }
  .weave-inputs-container .weave-table td {
    padding: 0.15rem;
  }
}
.weave-inputs-container .loading-overlay {
  position: relative;
}
.weave-inputs-container .loading-overlay::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.8);
  z-index: 1000;
  border-radius: inherit;
}
html[data-coreui-theme=dark] .weave-inputs-container .loading-overlay::after {
  background: rgba(0, 0, 0, 0.8);
}
.weave-inputs-container .loading-overlay .spinner-border {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1001;
}
.weave-inputs-container .fade-in {
  animation: fadeIn 0.3s ease-in;
}
.weave-inputs-container .slide-up {
  animation: slideUp 0.4s ease-out;
}
@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}`, "",{"version":3,"sources":["webpack://./src/components/WeaveInputs/WeaveInputs.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAChB;EACE,eAAA;EACA,6DAAA;EACA,iBAAA;AACF;AAEE;EACE,6DAAA;EACA,kCAAA;AAAJ;AAIE;EACE,YAAA;EACA,mBAAA;EACA,yCAAA;EACA,gBAAA;EACA,6DAAA;EACA,+BAAA;AAFJ;AAII;EACE,2BAAA;EACA,2CAAA;AAFN;AAKI;EACE,4GAAA;EACA,yCAAA;AAHN;AAKM;EACE,0CAAA;AAHR;AAOI;EACE,6DAAA;EACA,YAAA;EACA,oBAAA;EACA,YAAA;AALN;AAOM;EACE,SAAA;EACA,gBAAA;EACA,iBAAA;EACA,qBAAA;AALR;AASI;EACE,aAAA;AAPN;AASM;EACE,uCAAA;AAPR;AAaE;EACE,YAAA;EACA,mBAAA;EACA,yCAAA;EACA,gBAAA;EACA,mBAAA;AAXJ;AAaI;EACE,uCAAA;EACA,iDAAA;EACA,yCAAA;AAXN;AAcI;EACE,6DAAA;EACA,2CAAA;EACA,qBAAA;EACA,aAAA;EACA,2BAAA;EACA,mBAAA;EACA,iBAAA;EACA,WAAA;AAZN;AAcM;EACE,4GAAA;EACA,wDAAA;AAZR;AAeM;EACE,YAAA;EACA,YAAA;EACA,iBAAA;EACA,cAAA;AAbR;AAeQ;EACE,cAAA;AAbV;AAeU;EACE,YAAA;EACA,mBAAA;EACA,qBAAA;EACA,gBAAA;EACA,cAAA;EACA,uBAAA;EACA,yBAAA;EACA,kBAAA;EACA,yBAAA;EACA,qBAAA;EACA,iBAAA;EACA,mBAAA;AAbZ;AAeY;EACE,cAAA;EACA,oCAAA;EACA,2BAAA;AAbd;AAgBY;EACE,0CAAA;AAdd;AAgBc;EACE,kCAAA;EACA,oCAAA;AAdhB;AAkBY;EACE,YAAA;EACA,6DAAA;EACA,+CAAA;AAhBd;AAkBc;EACE,WAAA;EACA,kBAAA;EACA,eAAA;EACA,SAAA;EACA,2BAAA;EACA,QAAA;EACA,SAAA;EACA,kCAAA;EACA,mCAAA;EACA,6BAAA;AAhBhB;AAoBY;EACE,iBAAA;AAlBd;AAwBM;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,YAAA;EACA,oBAAA;EACA,eAAA;AAtBR;AAyBM;EACE,aAAA;EACA,sBAAA;EACA,MAAA;EACA,sBAAA;EACA,iBAAA;EACA,qBAAA;EACA,sBAAA;EACA,oBAAA;AAvBR;AAyBQ;EACE,aAAA;EACA,YAAA;EACA,iBAAA;EACA,mBAAA;EACA,yBAAA;AAvBV;AAyBU;EACE,mBAAA;EACA,mBAAA;AAvBZ;AAyBY;EACE,kBAAA;EACA,wBAAA;EACA,mBAAA;AAvBd;AA2BU;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,YAAA;AAzBZ;AA2BY;EACE,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,yBAAA;EACA,qBAAA;EACA,SAAA;EACA,mBAAA;AAzBd;AA2Bc;EACE,0CAAA;AAzBhB;AA6BY;EACE,eAAA;EACA,gBAAA;AA3Bd;AA6Bc;EACE,kBAAA;EACA,kBAAA;EACA,uBAAA;EACE,gBAAA;EACF,sBAAA;EACE,iBAAA;EACA,kBAAA;AA3BlB;AA4BkB;EACE,cAAA;AA1BpB;AA6BgB;EACE,6CAAA;EACA,iDAAA;EACA,kCAAA;AA3BlB;AA8BgB;EACE,qBAAA;EACA,+CAAA;EACA,UAAA;AA5BlB;AAgCgB;EAEE,wBAAA;EACA,SAAA;AA/BlB;AAkCgB;EACE,qBAAA;EACA,0BAAA;AAhClB;AAoCc;EACE,gBAAA;EACA,uBAAA;AAlChB;AAoCgB;EACE,qBAAA;EACA,cAAA;EACA,6BAAA;AAlClB;AAoCkB;EACE,yBAAA;EACA,qBAAA;EACA,YAAA;EACA,eAAA;AAlCpB;AAqCkB;EACE,6CAAA;AAnCpB;AAsCgB;EACE,0BAAA;EACA,kBAAA;AApClB;AAsCgB;EACE,0BAAA;EACA,iBAAA;AApClB;AA0CY;EACE,yBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;AAxCd;AA0Cc;EACE,2BAAA;EACA,yCAAA;AAxChB;AA2Cc;EACE,qBAAA;EACA,cAAA;AAzChB;AA2CgB;EACE,yBAAA;EACA,qBAAA;EACA,YAAA;AAzClB;AA4CgB;EACE,YAAA;EACA,mBAAA;EACA,eAAA;AA1ClB;AA4CkB;EACE,eAAA;EACA,gBAAA;AA1CpB;AAoDI;EACE,iBAAA;EACA,cAAA;AAlDN;AAoDM;EACE,UAAA;EACA,WAAA;AAlDR;AAqDM;EACE,mBAAA;EACA,kBAAA;AAnDR;AAsDM;EACE,qDAAA;EACA,kBAAA;AApDR;AAsDQ;EACE,qDAAA;AApDV;AAyDQ;EACE,8CAAA;AAvDV;AA0DQ;EACE,qDAAA;AAxDV;AA0DU;EACE,qDAAA;AAxDZ;AA8DI;EACE,2BAAA;EACA,yBAAA;EACA,iBAAA;EACA,2BAAA;EACA,0BAAA;EACA,0BAAA;EACA,yBAAA;AA5DN;AA8DM;EACE,YAAA;EACA,uBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;AA5DR;AA8DQ;EACE,+CAAA;EACA,2CAAA;EACA,kBAAA;AA5DV;AA+DQ;EACE,kCAAA;EACA,uBAAA;AA7DV;AA+DU;EACE,0CAAA;AA7DZ;AAiEQ;EACE,qBAAA;EACA,0BAAA;AA/DV;AAiEU;EAEE,wBAAA;EACA,SAAA;AAhEZ;AAqEM;EACE,6DAAA;EACA,yBAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,uBAAA;EACA,cAAA;EACA,gBAAA;EACA,MAAA;EACA,WAAA;EACA,yBAAA;EACA,qBAAA;AAnER;AAqEQ;EACE,4GAAA;EACA,iDAAA;EACA,kCAAA;AAnEV;AAsEQ;EACE,oCAAA;EACA,oCAAA;EACA,6DAAA;EACA,gBAAA;EACA,OAAA;EACA,WAAA;AApEV;AAuEQ;EACE,mCAAA;EACA,mCAAA;EACA,6DAAA;EACA,gBAAA;EACA,+BAAA;EACA,WAAA;AArEV;AAwEQ;EACE,mCAAA;EACA,mCAAA;EACA,6DAAA;EACA,gBAAA;EACA,gEAAA;EACA,WAAA;EACA,2BAAA;AAtEV;AAyEQ;EACE,eAAA;EACA,eAAA;EACA,iBAAA;EACA,6DAAA;AAvEV;AA0EQ;EACE,eAAA;EACA,eAAA;EACA,6DAAA;AAxEV;AA2EQ;EACE,eAAA;EACA,eAAA;EACA,6DAAA;AAzEV;AA4EQ;EACE,eAAA;EACA,eAAA;EACA,6DAAA;AA1EV;AA6EQ;EACE,eAAA;EACA,eAAA;EACA,6DAAA;AA3EV;AA8EQ;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;AA5EV;AA8EU;EACE,WAAA;EACA,kBAAA;EACA,qBAAA;AA5EZ;AAgFQ;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,QAAA;EACA,QAAA;EACA,2BAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,kBAAA;EACA,cAAA;AA9EV;AAmFM;EACE,yBAAA;EACA,gBAAA;EACA,kBAAA;EACA,sBAAA;EACA,mBAAA;AAjFR;AAmFQ;EACE,iDAAA;EACA,kCAAA;AAjFV;AAoFQ;EACE,oCAAA;EACA,oCAAA;EACA,eAAA;EACA,gBAAA;EACA,OAAA;EACA,WAAA;EACA,uCAAA;AAlFV;AAoFU;EACE,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,yBAAA;EACA,uBAAA;AAlFZ;AAoFY;EACE,qBAAA;EACA,+CAAA;AAlFd;AAqFY;EACE,6CAAA;EACA,iDAAA;EACA,kCAAA;AAnFd;AAqFc;EACE,yCAAA;AAnFhB;AAyFQ;EACE,mCAAA;EACA,mCAAA;EACA,eAAA;EACA,gBAAA;EACA,+BAAA;EACA,WAAA;EACA,uCAAA;AAvFV;AAyFU;EACE,qBAAA;EACA,qDAAA;EACA,uBAAA;EACA,kBAAA;EACA,qCAAA;EACA,gBAAA;EACA,cAAA;EACA,yBAAA;EACA,kBAAA;AAvFZ;AAyFY;EACE,oGAAA;EACA,kCAAA;EACA,iDAAA;AAvFd;AA4FQ;EACE,mCAAA;EACA,mCAAA;EACA,eAAA;EACA,gBAAA;EACA,gEAAA;EACA,UAAA;EACA,uCAAA;EACA,2BAAA;AA1FV;AA4FU;EACE,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,yBAAA;EACA,uBAAA;AA1FZ;AA4FY;EACE,qBAAA;EACA,+CAAA;AA1Fd;AA6FY;EACE,6CAAA;EACA,iDAAA;EACA,kCAAA;AA3Fd;AA6Fc;EACE,yCAAA;AA3FhB;AAiGQ;EACE,eAAA;EACA,eAAA;EACA,eAAA;AA/FV;AAkGQ;EACE,eAAA;EACA,eAAA;EACA,0CAAA;EACA,gBAAA;EACA,cAAA;AAhGV;AAmGQ;EACE,eAAA;EACA,eAAA;EACA,0CAAA;EACA,gBAAA;EACA,cAAA;AAjGV;AAoGQ;EACE,eAAA;EACA,eAAA;EACA,gBAAA;EACA,0CAAA;AAlGV;AAoGU;EACE,iBAAA;EACA,kBAAA;AAlGZ;AAoGY;EACE,oBAAA;EACA,kBAAA;AAlGd;AAuGQ;EACE,eAAA;EACA,eAAA;EACA,gBAAA;AArGV;AAuGsB;EACV,uBAAA;EACA,yBAAA;EACA,kBAAA;AArGZ;AAuGY;EACE,sBAAA;AArGd;AA2GM;EACE,yBAAA;AAzGR;AA2GQ;EACE,2CAAA;AAzGV;AA2GU;EACE,sCAAA;AAzGZ;AA6GQ;EACE,0CAAA;AA3GV;AA+GU;EACE,0CAAA;AA7GZ;AA+GY;EACE,sCAAA;AA7Gd;AAiHU;EACE,uCAAA;AA/GZ;AAmHQ;EACE,6DAAA;EACA,gBAAA;AAjHV;AAmHU;EACE,qBAAA;EACA,iBAAA;EACA,cAAA;AAjHZ;AAmHY;EAEE,qDAAA;EACA,YAAA;EACA,eAAA;AAlHd;AAsHU;EACE,6DAAA;AApHZ;AAyHU;EACE,4BAAA;EACA,6BAAA;AAvHZ;AA4HM;EACE,gBAAA;EACA,OAAA;EACA,gGAAA;EACA,gGAAA;EACA,UAAA;EACA,uCAAA;EACA,2BAAA;AA1HR;AA6HM;EACE,6CAAA;AA3HR;AA6HQ;;;EAGE,uDAAA;AA3HV;AAiIE;EAEI;IACE,mBAAA;EAhIN;EAkIM;IACE,wBAAA;IACA,8BAAA;IACA,4BAAA;IACA,mBAAA;IACA,gBAAA;EAhIR;EAkIQ;IACE,sBAAA;IACA,cAAA;EAhIV;EAkIU;IACE,wBAAA;IACA,kBAAA;EAhIZ;EAkIY;IACE,aAAA;EAhId;EAuIQ;IACE,uBAAA;IACA,YAAA;EArIV;EAwIU;IACE,mBAAA;EAtIZ;EAyIU;IACE,mBAAA;IACA,mBAAA;EAvIZ;EAyIY;IACE,kBAAA;IACA,wBAAA;EAvId;EA4IQ;IACE,WAAA;EA1IV;EA6IQ;IACE,kBAAA;EA3IV;EA8IQ;IACE,kBAAA;IACA,wBAAA;EA5IV;AACF;AAmJE;EACE,gBAAA;EACA,cAAA;EACA,qBAAA;EACA,mBAAA;AAjJJ;AAmJI;EACE,kCAAA;AAjJN;AAoJI;EACE,WAAA;EACA,qBAAA;EACA,QAAA;EACA,SAAA;EACA,mBAAA;EACA,kCAAA;EACA,mCAAA;EACA,gCAAA;EACA,yBAAA;AAlJN;AAuJI;EACE,cAAA;EACA,SAAA;EACA,YAAA;AArJN;AAuJM;EACE,0BAAA;EACA,6BAAA;EACA,eAAA;AArJR;AAyJI;EACE,yBAAA;EACA,4BAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;AAvJN;AA2JE;;EAEE,yBAAA;EACA,qBAAA;EACA,qBAAA;EACA,mBAAA;EACA,yBAAA;AAzJJ;AA2JI;;EACE,qBAAA;EACA,8CAAA;EACA,2BAAA;AAxJN;AA2JI;;EACE,cAAA;EACA,kBAAA;AAxJN;AA2JI;;EACE,qBAAA;AAxJN;AA0JM;;EACE,qBAAA;EACA,4CAAA;AAvJR;AA2JI;;EACE,6CAAA;EACA,iDAAA;EACA,kCAAA;AAxJN;AA0JM;;EACE,yCAAA;AAvJR;AA0JM;;EACE,0CAAA;AAvJR;AA4JE;EAOE,qBAAA;EACA,0BAAA;AAhKJ;AAyJI;EAEE,wBAAA;EACA,SAAA;AAxJN;AAgKE;EACE,qBAAA;EACA,uBAAA;EACA,gBAAA;EACA,mBAAA;EACA,yBAAA;EACA,yBAAA;EACA,qBAAA;AA9JJ;AAgKI;EACE,6DAAA;EACA,YAAA;AA9JN;AAgKM;EACE,6DAAA;EACA,2BAAA;EACA,+CAAA;AA9JR;AAiKM;EACE,mBAAA;EACA,eAAA;EACA,gBAAA;AA/JR;AAoKM;EACE,yBAAA;EACA,cAAA;AAlKR;AAoKQ;EACE,yBAAA;EACA,2BAAA;EACA,+CAAA;AAlKV;AAyKE;EACE,qBAAA;EACA,YAAA;EACA,oBAAA;EACA,qBAAA;AAvKJ;AAyKI;EACE,6DAAA;EACA,cAAA;EACA,8BAAA;AAvKN;AA0KI;EACE,6DAAA;EACA,cAAA;EACA,8BAAA;AAxKN;AA2KI;EACE,6DAAA;EACA,cAAA;EACA,8BAAA;AAzKN;AA8KE;EACE,yBAAA;EACA,kBAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;AA5KJ;AA8KI;EACE,aAAA;EACA,qBAAA;AA5KN;AAiLE;EACE,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,yBAAA;EACA,qBAAA;EACA,gBAAA;EACA,yBAAA;AA/KJ;AAiLI;EACE,qBAAA;EACA,8CAAA;AA/KN;AAkLI;EACE,uCAAA;EACA,iDAAA;AAhLN;AAkLM;EACE,yCAAA;AAhLR;AAoLI;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,iBAAA;AAlLN;AAqLI;;EAEE,uBAAA;EACA,kCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,uBAAA;EACA,2BAAA;AAnLN;AAqLM;;EACE,aAAA;EACA,gDAAA;AAlLR;AAqLM;;EACE,cAAA;EACA,gBAAA;AAlLR;AAqLM;;EACE,kCAAA;AAlLR;AAoLQ;;EACE,0CAAA;AAjLV;AAsLM;;;EAEE,wBAAA;EACA,SAAA;AAnLR;AAsLM;;EACE,qBAAA;EACA,0BAAA;AAnLR;AAuLI;EACE,SAAA;EACA,eAAA;EACA,iBAAA;EACA,qBAAA;AArLN;AAwLI;EACE,WAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;AAtLN;AAyLI;EACE,gBAAA;EACA,iBAAA;EACA,cAAA;EACA,iBAAA;AAvLN;AAyLM;EACE,kCAAA;AAvLR;AA2LI;EACE,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;EACA,mBAAA;AAzLN;AA2LM;EACE,0CAAA;AAzLR;AA+LI;EACE,0BAAA;EACA,mBAAA;EACA,iBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,yBAAA;AA7LN;AA+LM;EACE,qBAAA;EACA,mBAAA;AA7LR;AAgMM;EACE,uCAAA;EACA,iDAAA;AA9LR;AAgMQ;EACE,yCAAA;EACA,oCAAA;AA9LV;AAmMI;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,WAAA;EACA,cAAA;EACA,kBAAA;AAjMN;AAmMM;EACE,kBAAA;EACA,WAAA;AAjMR;AAqMI;EACE,kBAAA;EACA,WAAA;EACA,aAAA;EACA,gBAAA;EACA,mBAAA;AAnMN;AAqMM;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AAnMR;AAsMM;EACE,kBAAA;EACA,QAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;AApMR;AAyME;EACE,aAAA;EACA,mBAAA;EACA,WAAA;AAvMJ;AAyMI;EACE,aAAA;EACA,mBAAA;EACA,WAAA;AAvMN;AA0MI;EACE,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,qBAAA;EACA,gBAAA;EACA,mBAAA;AAxMN;AA0MM;EACE,0CAAA;AAxMR;AA4MI;EACE,gBAAA;EACA,YAAA;AA1MN;AA6MI;EACE,YAAA;AA3MN;AA6MM;EACE,WAAA;EACA,YAAA;EACA,QAAA;EACA,UAAA;AA3MR;AA+MI;EACE,YAAA;EACA,kBAAA;AA7MN;AA+MM;EACE,eAAA;AA7MR;AAgNM;EACE,kBAAA;AA9MR;AAoNI;EACE,WAAA;EACA,gBAAA;EACA,mBAAA;AAlNN;AAuNI;EACE,kBAAA;EACA,WAAA;EACA,aAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;AArNN;AAuNM;EACE,WAAA;EACA,YAAA;AArNR;AAyNI;EACE,aAAA;EACA,6BAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;AAvNN;AA0NI;EACE,aAAA;EACA,mBAAA;EACA,WAAA;AAxNN;AA0NM;EACE,kBAAA;EACA,gBAAA;AAxNR;AA4NI;EACE,aAAA;EACA,mBAAA;EACA,YAAA;AA1NN;AA4NM;EACE,kBAAA;EACA,gBAAA;EACA,SAAA;AA1NR;AA6NM;EACE,YAAA;AA3NR;AA+NI;EACE,aAAA;EACA,WAAA;AA7NN;AAkOE;EA7xCF;IA8xCI,aAAA;EA/NF;EAiOE;;IAEE,mBAAA;EA/NJ;EAiOI;;IACE,eAAA;EA9NN;AACF;AAoOQ;EADF;IAEI,aAAA;IACA,cAAA;IACA,mBAAA;EAjOR;AACF;AAmOQ;EAPF;IAQI,cAAA;IACA,eAAA;EAhOR;AACF;AAwME;EA4BE;IACE,wBAAA;IACA,sBAAA;IACA,oBAAA;EAjOJ;EAmOI;IACE,qBAAA;IACA,uBAAA;EAjON;EAmOM;IACE,sBAAA;IACA,mBAAA;IACA,YAAA;EAjOR;EAoOM;IACE,uBAAA;EAlOR;EAsOI;IACE,WAAA;IACA,sBAAA;IACA,mBAAA;EApON;EAsOM;IACE,WAAA;EApOR;EAsOQ;IACE,kBAAA;IACA,qBAAA;IACA,WAAA;EApOV;EAsOU;IACE,aAAA;EApOZ;EA0OI;IACE,WAAA;IACA,eAAA;EAxON;EA0OM;IACE,uBAAA;IACA,WAAA;EAxOR;EA2OU;IACE,eAAA;IACA,eAAA;EAzOZ;EA4OU;IACE,kBAAA;EA1OZ;EAiPE;IACE,iBAAA;EA/OJ;EAkPE;IACE,2BAAA;IACA,0BAAA;IACA,0BAAA;EAhPJ;EAoPM;;IACE,oCAAA;IACA,oCAAA;EAjPR;EAoPM;;IACE,mCAAA;IACA,mCAAA;EAjPR;EAoPM;;IACE,mCAAA;IACA,mCAAA;EAjPR;EAoPM;;IACE,eAAA;IACA,eAAA;EAjPR;EAoPM;;IACE,eAAA;IACA,eAAA;EAjPR;AACF;AAsPE;EACE;IACE,oBAAA;IACA,kBAAA;EApPJ;EAuPE;;IAEE,uBAAA;IACA,iBAAA;EArPJ;EA0PM;IACE,sBAAA;IACA,mBAAA;EAxPR;EA0PQ;IACE,WAAA;IACA,gBAAA;EAxPV;EA0PU;IACE,gBAAA;IACA,gBAAA;EAxPZ;EA+PE;IACE,kBAAA;EA7PJ;EA+PI;IACE,iBAAA;IACA,gBAAA;EA7PN;EAgQI;IACE,wBAAA;IACA,kBAAA;EA9PN;EAiQI;IACE,gBAAA;EA/PN;AACF;AAoQE;EACE,kBAAA;AAlQJ;AAoQI;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,oCAAA;EACA,aAAA;EACA,sBAAA;AAlQN;AAsQM;EACE,8BAAA;AApQR;AAwQI;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,aAAA;AAtQN;AA2QE;EACE,8BAAA;AAzQJ;AA4QE;EACE,gCAAA;AA1QJ;AA6QE;EACE;IAAO,UAAA;EA1QT;EA2QE;IAAK,UAAA;EAxQP;AACF;AA0QE;EACE;IACE,UAAA;IACA,2BAAA;EAxQJ;EA0QE;IACE,UAAA;IACA,wBAAA;EAxQJ;AACF","sourcesContent":["// WeaveInputs.scss - Enhanced with bulk controls\n.weave-inputs-container {\n  padding: 1.5rem;\n  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);\n  min-height: 100vh;\n  \n  // Dark mode support\n  html[data-coreui-theme=\"dark\"] & {\n    background: linear-gradient(135deg, #1a1d24 0%, #2c3034 100%);\n    color: var(--cui-body-color, #fff);\n  }\n\n  // Form Card\n  .weave-form-card {\n    border: none;\n    border-radius: 20px;\n    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);\n    overflow: hidden;\n    background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);\n    transition: transform 0.3s ease;\n\n    &:hover {\n      transform: translateY(-2px);\n      box-shadow: 0 12px 40px rgba(0, 0, 0, 0.12);\n    }\n    \n    html[data-coreui-theme=\"dark\"] & {\n      background: linear-gradient(135deg, var(--cui-dark-bg, #212631) 0%, var(--cui-dark-bg-subtle, #2c3034) 100%);\n      box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);\n      \n      &:hover {\n        box-shadow: 0 12px 40px rgba(0, 0, 0, 0.4);\n      }\n    }\n\n    .weave-form-header {\n      background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n      color: white;\n      padding: 1.5rem 2rem;\n      border: none;\n\n      h5 {\n        margin: 0;\n        font-weight: 700;\n        font-size: 1.3rem;\n        letter-spacing: 0.5px;\n      }\n    }\n\n    .card-body {\n      padding: 2rem;\n      \n      html[data-coreui-theme=\"dark\"] & {\n        background: var(--cui-dark-bg, #212631);\n      }\n    }\n  }\n\n  // Tabs Card\n  .weave-tabs-card {\n    border: none;\n    border-radius: 20px;\n    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);\n    overflow: hidden;\n    margin-bottom: 2rem;\n    \n    html[data-coreui-theme=\"dark\"] & {\n      background: var(--cui-dark-bg, #212631);\n      border-color: var(--cui-dark-border-subtle, #333);\n      box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);\n    }\n\n    .tabs-header {\n      background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);\n      border-bottom: 1px solid rgba(0, 0, 0, 0.1);\n      padding: 1rem 1.25rem;\n      display: flex;\n      justify-content: flex-start;\n      align-items: center;\n      flex-wrap: nowrap;\n      gap: 0.5rem;\n      \n      html[data-coreui-theme=\"dark\"] & {\n        background: linear-gradient(135deg, var(--cui-dark-bg-subtle, #2c3034) 0%, var(--cui-dark-bg, #212631) 100%);\n        border-bottom-color: var(--cui-dark-border-subtle, #333);\n      }\n\n      .weave-tabs {\n        border: none;\n        gap: 0.35rem;\n        flex-wrap: nowrap;\n        flex: 0 0 auto;\n\n        .nav-item {\n          flex: 0 0 auto;\n\n          .weave-tab-link {\n            border: none;\n            border-radius: 12px;\n            padding: 0.55rem 1rem;\n            font-weight: 600;\n            color: #6c757d;\n            background: transparent;\n            transition: all 0.3s ease;\n            position: relative;\n            text-transform: uppercase;\n            letter-spacing: 0.5px;\n            font-size: 0.8rem;\n            white-space: nowrap;\n\n            &:hover {\n              color: #495057;\n              background: rgba(255, 255, 255, 0.7);\n              transform: translateY(-2px);\n            }\n            \n            html[data-coreui-theme=\"dark\"] & {\n              color: var(--cui-secondary-color, #8a93a2);\n              \n              &:hover {\n                color: var(--cui-body-color, #fff);\n                background: rgba(255, 255, 255, 0.1);\n              }\n            }\n\n            &.active {\n              color: white;\n              background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n              box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);\n              \n              &::after {\n                content: '';\n                position: absolute;\n                bottom: -1.5rem;\n                left: 50%;\n                transform: translateX(-50%);\n                width: 0;\n                height: 0;\n                border-left: 8px solid transparent;\n                border-right: 8px solid transparent;\n                border-top: 8px solid #764ba2;\n              }\n            }\n\n            svg {\n              font-size: 1.1rem;\n            }\n          }\n        }\n      }\n\n      .tabs-photo-upload {\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        flex: 0 0 auto;\n        min-width: 0;\n        margin-left: 0.35rem;\n        margin-right: 0;\n      }\n\n      .table-controls {\n        display: flex;\n        flex-direction: column;\n        gap: 0;\n        min-width: fit-content;\n        margin-left: auto;\n        margin-right: 6.35rem;\n        align-self: flex-start;\n        margin-top: -0.12rem;\n\n        .bulk-controls-row {\n          display: flex;\n          gap: 0.55rem;\n          flex-wrap: nowrap;\n          align-items: center;\n          justify-content: flex-end;\n\n          .control-group:last-child {\n            margin-top: 0.22rem;\n            margin-left: 0.3rem;\n\n            .btn:not(.input-group .btn) {\n              font-size: 0.74rem;\n              padding: 0.34rem 0.78rem;\n              border-width: 1.8px;\n            }\n          }\n\n          .control-group {\n            display: flex;\n            flex-direction: column;\n            align-items: center;\n            gap: 0.25rem;\n\n            .control-label {\n              font-size: 0.7rem;\n              font-weight: 600;\n              color: #6c757d;\n              text-transform: uppercase;\n              letter-spacing: 0.5px;\n              margin: 0;\n              white-space: nowrap;\n              \n              html[data-coreui-theme=\"dark\"] & {\n                color: var(--cui-secondary-color, #8a93a2);\n              }\n            }\n\n            .bulk-input-group {\n              min-width: 80px;\n              max-width: 108px;\n              \n              .bulk-number-input {\n                font-size: 0.75rem;\n                text-align: center;\n                padding: 0.25rem 0.5rem;\n                  border-radius: 0;\n                background-color: #fff;\n                  border-left: none;\n                  border-right: none;\n                  &.has-left-button {\n                    border-left: 0;\n                  }\n                \n                html[data-coreui-theme=\"dark\"] & {\n                  background-color: var(--cui-dark-bg, #212631);\n                  border-color: var(--cui-dark-border-subtle, #333);\n                  color: var(--cui-body-color, #fff);\n                }\n\n                &:focus {\n                  border-color: #667eea;\n                  box-shadow: 0 0 0 2px rgba(102, 126, 234, 0.25);\n                  z-index: 3;\n                }\n                \n                // Hide number input spinners\n                &::-webkit-outer-spin-button,\n                &::-webkit-inner-spin-button {\n                  -webkit-appearance: none;\n                  margin: 0;\n                }\n                \n                &[type=number] {\n                  appearance: textfield;\n                  -moz-appearance: textfield;\n                }\n              }\n\n              .btn {\n                border-radius: 0;\n                padding: 0.25rem 0.5rem;\n                \n                &.btn-outline-success {\n                  border-color: #28a745;\n                  color: #28a745;\n                  background-color: transparent;\n                  \n                  &:hover {\n                    background-color: #28a745;\n                    border-color: #28a745;\n                    color: white;\n                    transform: none; // Override default hover transform\n                  }\n                  \n                  &:focus {\n                    box-shadow: 0 0 0 2px rgba(40, 167, 69, 0.25);\n                  }\n                }\n                &.left-btn {\n                  border-radius: 6px 0 0 6px;\n                  border-right: none;\n                }\n                &.right-btn {\n                  border-radius: 0 6px 6px 0;\n                  border-left: none;\n                }\n              }\n            }\n\n            // Standalone button (remove column)\n            .btn:not(.input-group .btn) {\n              transition: all 0.2s ease;\n              border-width: 1.5px;\n              font-weight: 500;\n              padding: 0.28rem 0.6rem;\n              border-radius: 6px;\n              font-size: 0.68rem;\n              white-space: nowrap;\n              \n              &:hover {\n                transform: translateY(-1px);\n                box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);\n              }\n              \n              &.btn-outline-danger {\n                border-color: #dc3545;\n                color: #dc3545;\n                \n                &:hover {\n                  background-color: #dc3545;\n                  border-color: #dc3545;\n                  color: white;\n                }\n\n                &:disabled {\n                  opacity: 0.5;\n                  cursor: not-allowed;\n                  transform: none;\n                  \n                  &:hover {\n                    transform: none;\n                    box-shadow: none;\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n    \n    .weave-table-container {\n      max-height: 600px;\n      overflow: auto;\n      \n      &::-webkit-scrollbar {\n        width: 8px;\n        height: 8px;\n      }\n      \n      &::-webkit-scrollbar-track {\n        background: #f1f1f1;\n        border-radius: 4px;\n      }\n      \n      &::-webkit-scrollbar-thumb {\n        background: linear-gradient(135deg, #667eea, #764ba2);\n        border-radius: 4px;\n        \n        &:hover {\n          background: linear-gradient(135deg, #5a6fd8, #6a42a0);\n        }\n      }\n      \n      html[data-coreui-theme=\"dark\"] & {\n        &::-webkit-scrollbar-track {\n          background: var(--cui-dark-bg-subtle, #2c3034);\n        }\n        \n        &::-webkit-scrollbar-thumb {\n          background: linear-gradient(135deg, #4a5568, #2d3748);\n          \n          &:hover {\n            background: linear-gradient(135deg, #2d3748, #1a202c);\n          }\n        }\n      }\n    }\n    \n    .weave-table {\n      margin-bottom: 0 !important;\n      border-collapse: separate;\n      border-spacing: 0;\n      --sticky-color-width: 150px;\n      --sticky-code-width: 120px;\n      --sticky-yarn-width: 150px;\n      --sticky-cell-bg: #ffffff;\n      \n      .table-input {\n        border: none;\n        background: transparent;\n        text-align: center;\n        font-weight: 500;\n        padding: 0.25rem;\n        min-width: 50px;\n        transition: all 0.2s ease;\n        \n        &:focus {\n          box-shadow: 0 0 0 2px rgba(102, 126, 234, 0.25);\n          background-color: rgba(102, 126, 234, 0.05);\n          border-radius: 6px;\n        }\n        \n        html[data-coreui-theme=\"dark\"] & {\n          color: var(--cui-body-color, #fff);\n          background: transparent;\n          \n          &:focus {\n            background-color: rgba(102, 126, 234, 0.1);\n          }\n        }\n        \n        &[type=\"number\"] {\n          appearance: textfield;\n          -moz-appearance: textfield;\n          \n          &::-webkit-outer-spin-button,\n          &::-webkit-inner-spin-button {\n            -webkit-appearance: none;\n            margin: 0;\n          }\n        }\n      }\n      \n      th {\n        background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);\n        border: 1px solid #dee2e6;\n        font-weight: 600;\n        font-size: 0.75rem;\n        text-align: center;\n        padding: 0.5rem 0.25rem;\n        color: #495057;\n        position: sticky;\n        top: 0;\n        z-index: 10;\n        text-transform: uppercase;\n        letter-spacing: 0.5px;\n        \n        html[data-coreui-theme=\"dark\"] & {\n          background: linear-gradient(135deg, var(--cui-dark-bg-subtle, #2c3034) 0%, var(--cui-dark-bg, #212631) 100%);\n          border-color: var(--cui-dark-border-subtle, #333);\n          color: var(--cui-body-color, #fff);\n        }\n        \n        &.color-column {\n          min-width: var(--sticky-color-width);\n          max-width: var(--sticky-color-width);\n          background: linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%);\n          position: sticky;\n          left: 0;\n          z-index: 14;\n        }\n        \n        &.code-column {\n          min-width: var(--sticky-code-width);\n          max-width: var(--sticky-code-width);\n          background: linear-gradient(135deg, #f3e5f5 0%, #e1bee7 100%);\n          position: sticky;\n          left: var(--sticky-color-width);\n          z-index: 13;\n        }\n        \n        &.yarn-column {\n          min-width: var(--sticky-yarn-width);\n          max-width: var(--sticky-yarn-width);\n          background: linear-gradient(135deg, #e8f5e8 0%, #c8e6c9 100%);\n          position: sticky;\n          left: calc(var(--sticky-color-width) + var(--sticky-code-width));\n          z-index: 12;\n          box-shadow: 1px 0 0 #ced4da;\n        }\n        \n        &.number-column {\n          min-width: 45px;\n          max-width: 45px;\n          font-size: 0.7rem;\n          background: linear-gradient(135deg, #fff3e0 0%, #ffcc02 100%);\n        }\n        \n        &.total-column {\n          min-width: 70px;\n          max-width: 70px;\n          background: linear-gradient(135deg, #e8f5e8 0%, #c8e6c9 100%);\n        }\n        \n        &.percent-column {\n          min-width: 60px;\n          max-width: 60px;\n          background: linear-gradient(135deg, #fff3e0 0%, #ffe0b2 100%);\n        }\n        \n        &.weight-column {\n          min-width: 80px;\n          max-width: 80px;\n          background: linear-gradient(135deg, #e1f5fe 0%, #b3e5fc 100%);\n        }\n        \n        &.action-column {\n          min-width: 70px;\n          max-width: 70px;\n          background: linear-gradient(135deg, #ffebee 0%, #ffcdd2 100%);\n        }\n\n        .header-with-action {\n          position: relative;\n          display: flex;\n          align-items: center;\n          justify-content: center;\n          width: 100%;\n\n          > span {\n            width: 100%;\n            text-align: center;\n            padding-right: 1.4rem;\n          }\n        }\n\n        .header-add-btn {\n          display: inline-flex;\n          align-items: center;\n          justify-content: center;\n          position: absolute;\n          right: 0;\n          top: 50%;\n          transform: translateY(-50%);\n          width: 22px;\n          height: 22px;\n          padding: 0;\n          border-radius: 6px;\n          flex-shrink: 0;\n        }\n\n      }\n      \n      td {\n        border: 1px solid #dee2e6;\n        padding: 0.25rem;\n        text-align: center;\n        vertical-align: middle;\n        font-size: 0.875rem;\n        \n        html[data-coreui-theme=\"dark\"] & {\n          border-color: var(--cui-dark-border-subtle, #333);\n          color: var(--cui-body-color, #fff);\n        }\n        \n        &.color-column {\n          min-width: var(--sticky-color-width);\n          max-width: var(--sticky-color-width);\n          padding: 0.5rem;\n          position: sticky;\n          left: 0;\n          z-index: 11;\n          background-color: var(--sticky-cell-bg);\n          \n          .form-select {\n            font-size: 0.75rem;\n            border: 1px solid #ced4da;\n            border-radius: 8px;\n            transition: all 0.2s ease;\n            background-color: white;\n            \n            &:focus {\n              border-color: #667eea;\n              box-shadow: 0 0 0 2px rgba(102, 126, 234, 0.25);\n            }\n            \n            html[data-coreui-theme=\"dark\"] & {\n              background-color: var(--cui-dark-bg, #212631);\n              border-color: var(--cui-dark-border-subtle, #333);\n              color: var(--cui-body-color, #fff);\n              \n              &:focus {\n                border-color: var(--cui-primary, #0d6efd);\n              }\n            }\n          }\n        }\n        \n        &.code-column {\n          min-width: var(--sticky-code-width);\n          max-width: var(--sticky-code-width);\n          padding: 0.5rem;\n          position: sticky;\n          left: var(--sticky-color-width);\n          z-index: 10;\n          background-color: var(--sticky-cell-bg);\n          \n          .color-code {\n            display: inline-block;\n            background: linear-gradient(135deg, #f8f9fa, #e9ecef);\n            padding: 0.25rem 0.5rem;\n            border-radius: 8px;\n            font-family: 'Courier New', monospace;\n            font-weight: 600;\n            color: #495057;\n            border: 1px solid #dee2e6;\n            font-size: 0.75rem;\n            \n            html[data-coreui-theme=\"dark\"] & {\n              background: linear-gradient(135deg, var(--cui-dark-bg-subtle, #2c3034), var(--cui-dark-bg, #212631));\n              color: var(--cui-body-color, #fff);\n              border-color: var(--cui-dark-border-subtle, #333);\n            }\n          }\n        }\n        \n        &.yarn-column {\n          min-width: var(--sticky-yarn-width);\n          max-width: var(--sticky-yarn-width);\n          padding: 0.5rem;\n          position: sticky;\n          left: calc(var(--sticky-color-width) + var(--sticky-code-width));\n          z-index: 9;\n          background-color: var(--sticky-cell-bg);\n          box-shadow: 1px 0 0 #ced4da;\n          \n          .form-select {\n            font-size: 0.75rem;\n            border: 1px solid #ced4da;\n            border-radius: 8px;\n            transition: all 0.2s ease;\n            background-color: white;\n            \n            &:focus {\n              border-color: #667eea;\n              box-shadow: 0 0 0 2px rgba(102, 126, 234, 0.25);\n            }\n            \n            html[data-coreui-theme=\"dark\"] & {\n              background-color: var(--cui-dark-bg, #212631);\n              border-color: var(--cui-dark-border-subtle, #333);\n              color: var(--cui-body-color, #fff);\n              \n              &:focus {\n                border-color: var(--cui-primary, #0d6efd);\n              }\n            }\n          }\n        }\n        \n        &.number-column {\n          min-width: 45px;\n          max-width: 45px;\n          padding: 0.1rem;\n        }\n        \n        &.total-column {\n          min-width: 70px;\n          max-width: 70px;\n          background-color: rgba(200, 230, 201, 0.1);\n          font-weight: 600;\n          color: #2e7d32;\n        }\n        \n        &.percent-column {\n          min-width: 60px;\n          max-width: 60px;\n          background-color: rgba(255, 224, 178, 0.1);\n          font-weight: 600;\n          color: #ef6c00;\n        }\n        \n        &.weight-column {\n          min-width: 80px;\n          max-width: 80px;\n          padding: 0.25rem;\n          background-color: rgba(179, 229, 252, 0.1);\n          \n          .table-input {\n            font-size: 0.7rem;\n            text-align: center;\n            \n            &::placeholder {\n              font-family: inherit;\n              font-size: 0.65rem;\n            }\n          }\n        }\n        \n        &.action-column {\n          min-width: 70px;\n          max-width: 70px;\n          padding: 0.25rem;\n          \n                      .btn {\n            padding: 0.25rem 0.5rem;\n            transition: all 0.2s ease;\n            border-radius: 6px;\n            \n            &:hover {\n              transform: scale(1.05);\n            }\n          }\n        }\n      }\n      \n      tbody tr {\n        transition: all 0.2s ease;\n        \n        &:hover {\n          background-color: rgba(102, 126, 234, 0.02);\n          \n          td {\n            border-color: rgba(102, 126, 234, 0.3);\n          }\n        }\n        \n        &:nth-child(even) {\n          background-color: rgba(248, 249, 250, 0.5);\n        }\n        \n        html[data-coreui-theme=\"dark\"] & {\n          &:hover {\n            background-color: rgba(102, 126, 234, 0.1);\n            \n            td {\n              border-color: rgba(102, 126, 234, 0.5);\n            }\n          }\n          \n          &:nth-child(even) {\n            background-color: rgba(44, 48, 52, 0.3);\n          }\n        }\n        \n        &.total-row {\n          background: linear-gradient(135deg, #e8f5e8 0%, #c8e6c9 100%);\n          font-weight: 700;\n          \n          td {\n            border-color: #4caf50;\n            border-width: 2px;\n            color: #1b5e20;\n            \n            &.total-column,\n            &.percent-column {\n              background: linear-gradient(135deg, #4caf50, #2e7d32);\n              color: white;\n              font-size: 1rem;\n            }\n          }\n          \n          &:hover {\n            background: linear-gradient(135deg, #c8e6c9 0%, #a5d6a7 100%);\n          }\n        }\n\n        &.factor-row {\n          td.factor-cell {\n            border-left: none !important;\n            border-right: none !important;\n          }\n        }\n      }\n\n      .sticky-summary-label {\n        position: sticky;\n        left: 0;\n        min-width: calc(var(--sticky-color-width) + var(--sticky-code-width) + var(--sticky-yarn-width));\n        max-width: calc(var(--sticky-color-width) + var(--sticky-code-width) + var(--sticky-yarn-width));\n        z-index: 8;\n        background-color: var(--sticky-cell-bg);\n        box-shadow: 1px 0 0 #ced4da;\n      }\n\n      html[data-coreui-theme=\"dark\"] & {\n        --sticky-cell-bg: var(--cui-dark-bg, #212631);\n\n        th.yarn-column,\n        td.yarn-column,\n        .sticky-summary-label {\n          box-shadow: 1px 0 0 var(--cui-dark-border-subtle, #333);\n        }\n      }\n    }\n  }\n\n  @media (min-width: 769px) {\n    .weave-tabs-card {\n      .tabs-header {\n        align-items: center;\n\n        .weave-tabs {\n          display: flex !important;\n          flex-direction: row !important;\n          flex-wrap: nowrap !important;\n          align-items: center;\n          margin-bottom: 0;\n\n          .nav-item {\n            width: auto !important;\n            flex: 0 0 auto;\n\n            .weave-tab-link {\n              padding: 0.68rem 1.25rem;\n              font-size: 0.86rem;\n\n              &.active::after {\n                display: none;\n              }\n            }\n          }\n        }\n\n        .table-controls {\n          .bulk-controls-row {\n            align-items: flex-start;\n            gap: 0.72rem;\n\n            // Move only SATIR and SUTUN groups a bit to the right.\n            .control-group:nth-child(-n+2) {\n              margin-left: 2.2rem;\n            }\n\n            .control-group:last-child {\n              margin-top: 1.26rem;\n              margin-left: 2.4rem;\n\n              .btn:not(.input-group .btn) {\n                font-size: 0.72rem;\n                padding: 0.32rem 0.74rem;\n              }\n            }\n          }\n\n          .control-group {\n            gap: 0.3rem;\n          }\n\n          .control-group .control-label {\n            font-size: 0.74rem;\n          }\n\n          .control-group .btn:not(.input-group .btn) {\n            font-size: 0.64rem;\n            padding: 0.22rem 0.52rem;\n          }\n        }\n      }\n    }\n  }\n    \n  // Form styling enhancements\n  .form-label {\n    font-weight: 600;\n    color: #495057;\n    margin-bottom: 0.5rem;\n    font-size: 0.875rem;\n    \n    html[data-coreui-theme=\"dark\"] & {\n      color: var(--cui-body-color, #fff);\n    }\n    \n    &::after {\n      content: '';\n      display: inline-block;\n      width: 0;\n      height: 0;\n      margin-left: 0.5rem;\n      border-left: 3px solid transparent;\n      border-right: 3px solid transparent;\n      border-bottom: 3px solid #667eea;\n      transition: all 0.2s ease;\n    }\n  }\n\n  .quick-create-select-group {\n    .quick-create-searchable-select {\n      flex: 1 1 auto;\n      width: 1%;\n      min-width: 0;\n\n      .select-trigger {\n        border-top-right-radius: 0;\n        border-bottom-right-radius: 0;\n        border-right: 0;\n      }\n    }\n\n    .btn {\n      border-top-left-radius: 0;\n      border-bottom-left-radius: 0;\n      display: inline-flex;\n      align-items: center;\n      justify-content: center;\n      min-width: 38px;\n    }\n  }\n  \n  .form-control,\n  .form-select {\n    border: 2px solid #e9ecef;\n    border-radius: 0.5rem;\n    padding: 0.75rem 1rem;\n    font-size: 0.875rem;\n    transition: all 0.3s ease;\n    \n    &:focus {\n      border-color: #667eea;\n      box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);\n      transform: translateY(-1px);\n    }\n    \n    &::placeholder {\n      color: #adb5bd;\n      font-style: italic;\n    }\n    \n    &.is-invalid {\n      border-color: #dc3545;\n      \n      &:focus {\n        border-color: #dc3545;\n        box-shadow: 0 0 0 3px rgba(220, 53, 69, 0.1);\n      }\n    }\n    \n    html[data-coreui-theme=\"dark\"] & {\n      background-color: var(--cui-dark-bg, #212631);\n      border-color: var(--cui-dark-border-subtle, #333);\n      color: var(--cui-body-color, #fff);\n      \n      &:focus {\n        border-color: var(--cui-primary, #0d6efd);\n      }\n      \n      &::placeholder {\n        color: var(--cui-secondary-color, #8a93a2);\n      }\n    }\n  }\n  \n  .form-control[type=\"number\"] {\n    &::-webkit-outer-spin-button,\n    &::-webkit-inner-spin-button {\n      -webkit-appearance: none;\n      margin: 0;\n    }\n    \n    appearance: textfield;\n    -moz-appearance: textfield;\n  }\n  \n  // Button styling\n  .btn {\n    border-radius: 0.5rem;\n    padding: 0.75rem 1.5rem;\n    font-weight: 600;\n    font-size: 0.875rem;\n    transition: all 0.3s ease;\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n    \n    &.btn-primary {\n      background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n      border: none;\n      \n      &:hover {\n        background: linear-gradient(135deg, #5a6fd8 0%, #6a42a0 100%);\n        transform: translateY(-2px);\n        box-shadow: 0 8px 25px rgba(102, 126, 234, 0.3);\n      }\n      \n      &:disabled {\n        background: #adb5bd;\n        transform: none;\n        box-shadow: none;\n      }\n    }\n    \n    &.btn-secondary {\n      &.btn-outline {\n        border: 2px solid #6c757d;\n        color: #6c757d;\n        \n        &:hover {\n          background-color: #6c757d;\n          transform: translateY(-2px);\n          box-shadow: 0 8px 25px rgba(108, 117, 125, 0.2);\n        }\n      }\n    }\n  }\n  \n  // Alert styling\n  .alert {\n    border-radius: 0.5rem;\n    border: none;\n    padding: 1rem 1.5rem;\n    margin-bottom: 1.5rem;\n    \n    &.alert-success {\n      background: linear-gradient(135deg, #d4edda 0%, #c3e6cb 100%);\n      color: #155724;\n      border-left: 4px solid #28a745;\n    }\n    \n    &.alert-danger {\n      background: linear-gradient(135deg, #f8d7da 0%, #f5c6cb 100%);\n      color: #721c24;\n      border-left: 4px solid #dc3545;\n    }\n\n    &.alert-info {\n      background: linear-gradient(135deg, #d1ecf1 0%, #bee5eb 100%);\n      color: #0c5460;\n      border-left: 4px solid #17a2b8;\n    }\n  }\n  \n  // Invalid feedback styling\n  .invalid-feedback {\n    display: block !important;\n    font-size: 0.75rem;\n    color: #dc3545;\n    margin-top: 0.25rem;\n    font-weight: 500;\n    \n    &::before {\n      content: '⚠ ';\n      margin-right: 0.25rem;\n    }\n  }\n\n  // Fabric Weight Input Group (similar to price-input-group in OrderInputs)\n  .fabric-weight-input-group {\n    display: flex;\n    align-items: center;\n    background: #fff;\n    border: 2px solid #e9ecef;\n    border-radius: 0.5rem;\n    overflow: hidden;\n    transition: all 0.3s ease;\n\n    &:focus-within {\n      border-color: #667eea;\n      box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);\n    }\n\n    html[data-coreui-theme=\"dark\"] & {\n      background: var(--cui-dark-bg, #212631);\n      border-color: var(--cui-dark-border-subtle, #333);\n\n      &:focus-within {\n        border-color: var(--cui-primary, #0d6efd);\n      }\n    }\n\n    .weight-input-section {\n      display: flex;\n      align-items: center;\n      flex: 1;\n      padding: 0 0.5rem;\n    }\n\n    .weight-whole,\n    .weight-decimal {\n      border: none !important;\n      background: transparent !important;\n      text-align: center;\n      font-weight: 600;\n      font-size: 1rem;\n      padding: 0.5rem 0.25rem;\n      box-shadow: none !important;\n\n      &:focus {\n        outline: none;\n        background: rgba(102, 126, 234, 0.05) !important;\n      }\n\n      &::placeholder {\n        color: #adb5bd;\n        font-weight: 400;\n      }\n\n      html[data-coreui-theme=\"dark\"] & {\n        color: var(--cui-body-color, #fff);\n\n        &::placeholder {\n          color: var(--cui-secondary-color, #8a93a2);\n        }\n      }\n\n      // Hide number input spinners\n      &::-webkit-outer-spin-button,\n      &::-webkit-inner-spin-button {\n        -webkit-appearance: none;\n        margin: 0;\n      }\n\n      &[type=number] {\n        appearance: textfield;\n        -moz-appearance: textfield;\n      }\n    }\n\n    .weight-whole {\n      flex: 1;\n      min-width: 60px;\n      text-align: right;\n      padding-right: 0.1rem;\n    }\n\n    .weight-decimal {\n      width: 50px;\n      min-width: 50px;\n      text-align: left;\n      padding-left: 0.1rem;\n    }\n\n    .decimal-separator {\n      font-weight: 700;\n      font-size: 1.2rem;\n      color: #495057;\n      padding: 0 0.1rem;\n\n      html[data-coreui-theme=\"dark\"] & {\n        color: var(--cui-body-color, #fff);\n      }\n    }\n\n    .unit-label {\n      font-size: 0.75rem;\n      font-weight: 600;\n      color: #6c757d;\n      padding: 0 0.5rem;\n      white-space: nowrap;\n\n      html[data-coreui-theme=\"dark\"] & {\n        color: var(--cui-secondary-color, #8a93a2);\n      }\n    }\n  }\n\n  .image-upload-section {\n    .image-upload-container {\n      border: 2px dashed #ced4da;\n      border-radius: 12px;\n      min-height: 170px;\n      cursor: pointer;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      background: #fff;\n      transition: all 0.2s ease;\n\n      &:hover {\n        border-color: #667eea;\n        background: #f8faff;\n      }\n\n      html[data-coreui-theme=\"dark\"] & {\n        background: var(--cui-dark-bg, #212631);\n        border-color: var(--cui-dark-border-subtle, #333);\n\n        &:hover {\n          border-color: var(--cui-primary, #0d6efd);\n          background: rgba(13, 110, 253, 0.08);\n        }\n      }\n    }\n\n    .upload-placeholder {\n      display: flex;\n      flex-direction: column;\n      align-items: center;\n      gap: 0.4rem;\n      color: #6c757d;\n      font-size: 0.85rem;\n\n      .upload-hint {\n        font-size: 0.75rem;\n        color: #999;\n      }\n    }\n\n    .image-preview-wrapper {\n      position: relative;\n      width: 100%;\n      height: 170px;\n      overflow: hidden;\n      border-radius: 10px;\n\n      .image-preview {\n        width: 100%;\n        height: 100%;\n        object-fit: cover;\n      }\n\n      .remove-image-btn {\n        position: absolute;\n        top: 8px;\n        right: 8px;\n        width: 28px;\n        height: 28px;\n        padding: 0;\n        border-radius: 50%;\n        display: inline-flex;\n        align-items: center;\n        justify-content: center;\n      }\n    }\n  }\n\n  .image-upload-section.compact-image-upload {\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n\n    .compact-image-row {\n      display: flex;\n      align-items: center;\n      gap: 0.5rem;\n    }\n\n    .compact-image-label {\n      font-size: 0.68rem;\n      font-weight: 700;\n      color: #6c757d;\n      letter-spacing: 0.2px;\n      margin-bottom: 0;\n      white-space: nowrap;\n\n      html[data-coreui-theme=\"dark\"] & {\n        color: var(--cui-secondary-color, #8a93a2);\n      }\n    }\n\n    .image-upload-container {\n      min-height: 56px;\n      width: 128px;\n    }\n\n    .image-preview-wrapper {\n      height: 64px;\n\n      .remove-image-btn {\n        width: 22px;\n        height: 22px;\n        top: 5px;\n        right: 5px;\n      }\n    }\n\n    .upload-placeholder {\n      gap: 0.15rem;\n      font-size: 0.62rem;\n\n      svg {\n        font-size: 1rem;\n      }\n\n      .upload-hint {\n        font-size: 0.56rem;\n      }\n    }\n  }\n\n  .image-preview-modal {\n    .preview-image {\n      width: 100%;\n      max-height: 70vh;\n      object-fit: contain;\n    }\n  }\n\n  .crop-modal {\n    .crop-container {\n      position: relative;\n      width: 100%;\n      height: 420px;\n      background: #111;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      overflow: hidden;\n      \n      .react-easy-crop_container {\n        width: 100%;\n        height: 100%;\n      }\n    }\n\n    .crop-controls {\n      padding: 1rem;\n      border-top: 1px solid #e9ecef;\n      display: flex;\n      justify-content: space-between;\n      align-items: center;\n      gap: 1rem;\n      flex-wrap: wrap;\n    }\n\n    .crop-size-options {\n      display: flex;\n      align-items: center;\n      gap: 0.5rem;\n\n      span {\n        font-size: 0.85rem;\n        font-weight: 600;\n      }\n    }\n\n    .zoom-control {\n      display: flex;\n      align-items: center;\n      gap: 0.75rem;\n\n      label {\n        font-size: 0.85rem;\n        font-weight: 600;\n        margin: 0;\n      }\n\n      .zoom-slider {\n        width: 220px;\n      }\n    }\n\n    .crop-actions {\n      display: flex;\n      gap: 0.5rem;\n    }\n  }\n  \n  // Responsive adjustments\n  @media (max-width: 768px) {\n    padding: 1rem;\n\n    .weave-form-card,\n    .weave-tabs-card {\n      border-radius: 16px;\n\n      .card-body {\n        padding: 1.5rem;\n      }\n    }\n\n    // Adjust form layout for smaller screens\n    .row {\n      .col-md-2 {\n        @media (max-width: 768px) {\n          flex: 0 0 50%;\n          max-width: 50%;\n          margin-bottom: 1rem;\n        }\n        \n        @media (max-width: 576px) {\n          flex: 0 0 100%;\n          max-width: 100%;\n        }\n      }\n    }\n\n    .tabs-header {\n      padding: 1rem !important;\n      flex-direction: column;\n      align-items: stretch;\n\n      .tabs-photo-upload {\n        margin: 0 0 0.75rem 0;\n        justify-content: center;\n\n        .compact-image-upload {\n          flex-direction: column;\n          align-items: center;\n          gap: 0.45rem;\n        }\n\n        .compact-image-row {\n          justify-content: center;\n        }\n      }\n\n      .weave-tabs {\n        width: 100%;\n        flex-direction: column;\n        margin-bottom: 1rem;\n\n        .nav-item {\n          width: 100%;\n\n          .weave-tab-link {\n            text-align: center;\n            padding: 0.75rem 1rem;\n            width: 100%;\n\n            &.active::after {\n              display: none;\n            }\n          }\n        }\n      }\n\n      .table-controls {\n        width: 100%;\n        min-width: auto;\n\n        .bulk-controls-row {\n          justify-content: center;\n          gap: 0.5rem;\n          \n          .control-group {\n            .bulk-input-group {\n              min-width: 70px;\n              max-width: 90px;\n            }\n            \n            .control-label {\n              font-size: 0.65rem;\n            }\n          }\n        }\n      }\n    }\n\n    .weave-table-container {\n      max-height: 400px;\n    }\n    \n    .weave-table {\n      --sticky-color-width: 120px;\n      --sticky-code-width: 100px;\n      --sticky-yarn-width: 120px;\n\n      th,\n      td {\n        &.color-column {\n          min-width: var(--sticky-color-width);\n          max-width: var(--sticky-color-width);\n        }\n        \n        &.code-column {\n          min-width: var(--sticky-code-width);\n          max-width: var(--sticky-code-width);\n        }\n        \n        &.yarn-column {\n          min-width: var(--sticky-yarn-width);\n          max-width: var(--sticky-yarn-width);\n        }\n        \n        &.number-column {\n          min-width: 40px;\n          max-width: 40px;\n        }\n        \n        &.weight-column {\n          min-width: 70px;\n          max-width: 70px;\n        }\n      }\n    }\n  }\n  \n  @media (max-width: 576px) {\n    .btn {\n      padding: 0.5rem 1rem;\n      font-size: 0.75rem;\n    }\n    \n    .form-control,\n    .form-select {\n      padding: 0.5rem 0.75rem;\n      font-size: 0.8rem;\n    }\n    \n    .tabs-header {\n      .table-controls {\n        .bulk-controls-row {\n          flex-direction: column;\n          align-items: center;\n          \n          .control-group {\n            width: 100%;\n            max-width: 200px;\n            \n            .bulk-input-group {\n              min-width: 100px;\n              max-width: 150px;\n            }\n          }\n        }\n      }\n    }\n    \n    .weave-table {\n      font-size: 0.75rem;\n      \n      .table-input {\n        font-size: 0.7rem;\n        padding: 0.15rem;\n      }\n      \n      th {\n        padding: 0.25rem 0.15rem;\n        font-size: 0.65rem;\n      }\n      \n      td {\n        padding: 0.15rem;\n      }\n    }\n  }\n  \n  // Loading state\n  .loading-overlay {\n    position: relative;\n    \n    &::after {\n      content: '';\n      position: absolute;\n      top: 0;\n      left: 0;\n      right: 0;\n      bottom: 0;\n      background: rgba(255, 255, 255, 0.8);\n      z-index: 1000;\n      border-radius: inherit;\n    }\n    \n    html[data-coreui-theme=\"dark\"] & {\n      &::after {\n        background: rgba(0, 0, 0, 0.8);\n      }\n    }\n    \n    .spinner-border {\n      position: absolute;\n      top: 50%;\n      left: 50%;\n      transform: translate(-50%, -50%);\n      z-index: 1001;\n    }\n  }\n  \n  // Animation classes\n  .fade-in {\n    animation: fadeIn 0.3s ease-in;\n  }\n  \n  .slide-up {\n    animation: slideUp 0.4s ease-out;\n  }\n  \n  @keyframes fadeIn {\n    from { opacity: 0; }\n    to { opacity: 1; }\n  }\n  \n  @keyframes slideUp {\n    from {\n      opacity: 0;\n      transform: translateY(20px);\n    }\n    to {\n      opacity: 1;\n      transform: translateY(0);\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
